import { js_utils } from "../utils/frfr-js-utils";
import { _getParamsFromLibMaterijalLimParams } from "./ter-materijal-utils";
import { multitranslator_v1_dodaj_multiprevod_u_recnik, multitranslator_v2_dodaj_multiprevodJednogKljuca_u_recnikKljuceva, multitranslator_v2_extract_superlang_from_jezik, multitranslator_v2_napravi_novi_prazan_recnikKljuceva } from "./ter-multitranslator-utils";
import { _getParamSingleFromSifrarnikOp, _getParamSingleFromSifrarnikRadnicentri } from "./ter-params-utils";


// NOVO MULTITRANSLATOR LIB

let ter_recnik_kljuceva_initialized = false;
let ter_recnik_kljuceva_lib_optimized = {};


const _dodaj_multiprevod = multitranslator_v1_dodaj_multiprevod_u_recnik;


//
const _if_not_number_then_null = (value) => {
  if (js_utils.is_number(value)) {
    return value;
  }
  return null;
};


//
const _ter_prevodilac_dopuni_recnik_sa_default = (recnik, virtel) => {
  //
  //
  // Nivo: p.bomlevel,
  _dodaj_multiprevod(recnik, {
    by: "virtel_key",
    virtel_key: "bomlevel",
    value: virtel.bomlevel,
    sasint_key: "Nivo",
    // sasint_value: ,
  });
  // Nivo_importovani: p.bomlevel_imported,
  _dodaj_multiprevod(recnik, {
    by: "virtel_key",
    virtel_key: "bomlevel_imported",
    value: virtel.bomlevel_imported,
    sasint_key: "Nivo_importovani",
    // sasint_value: ,
  });
  // Kolicina: p.kolicina,
  _dodaj_multiprevod(recnik, {
    by: "virtel_key",
    virtel_key: "kolicina",
    value: virtel.kolicina,
    sasint_key: "Kolicina",
    // sasint_value: ,
  });
  // JM: p.jm,
  _dodaj_multiprevod(recnik, {
    by: "virtel_key",
    virtel_key: "jm",
    value: virtel.jm,
    sasint_key: "JM",
    // sasint_value: ,
  });
  // Kat: p.terkategorija,
  _dodaj_multiprevod(recnik, {
    by: "virtel_key",
    virtel_key: "terkategorija",
    value: virtel.terkategorija,
    sasint_key: "Kat",
    // sasint_value: ,
  });
  // Grupa: p.tergrupa,
  _dodaj_multiprevod(recnik, {
    by: "virtel_key",
    virtel_key: "tergrupa",
    value: virtel.tergrupa,
    sasint_key: "Grupa",
    // sasint_value: ,
  });
  // virtelclass: p.virtelclass, // NOVO
  _dodaj_multiprevod(recnik, {
    by: "virtel_key",
    virtel_key: "virtelclass",
    value: virtel.virtelclass,
    sasint_key: "virtelclass",
    // sasint_value: ,
  });
  // Calculated_ident: p.calculated_ident,
  _dodaj_multiprevod(recnik, {
    by: "virtel_key",
    virtel_key: "calculated_ident",
    value: virtel.calculated_ident,
    sasint_key: "Calculated_ident",
    // sasint_value: ,
  });
  // Custom_ident: p.identcustom,
  _dodaj_multiprevod(recnik, {
    by: "virtel_key",
    virtel_key: "identcustom",
    value: virtel.identcustom,
    sasint_key: "Custom_ident",
    // sasint_value: ,
  });
  // Genus_ident: p.genus_ident,
  _dodaj_multiprevod(recnik, {
    by: "virtel_key",
    virtel_key: "genus_ident",
    value: virtel.genus_ident,
    sasint_key: "Genus_ident",
    // sasint_value: ,
  });
  //
  // POLJA OD DOPUNE SASTAVNICE
  // acIdent: null,
  // acIdentChild: null,
  // infoID: null,
  //
  // POLJA OD OPERACIJA...
  // Operacija: _getParamSingleFromSifrarnikOp(p.operacija),
  _dodaj_multiprevod(recnik, {
    by: "virtel_key",
    virtel_key: "operacija",
    value: virtel.operacija,
    sasint_key: "Operacija",
    sasint_value: _getParamSingleFromSifrarnikOp(virtel.operacija),
  });
  // Radni_centar: _getParamSingleFromSifrarnikRadnicentri(p.rc),
  _dodaj_multiprevod(recnik, {
    by: "virtel_key",
    virtel_key: "rc",
    value: virtel.rc,
    sasint_key: "Radni_centar",
    sasint_value: _getParamSingleFromSifrarnikRadnicentri(virtel.rc),
  });
  // Broj_izvrsioca: angazovanihradnika,
  _dodaj_multiprevod(recnik, {
    by: "virtel_key",
    virtel_key: "angazovanihradnika",
    value: virtel.angazovanihradnika,
    sasint_key: "Broj_izvrsioca",
    sasint_value: _if_not_number_then_null(virtel.angazovanihradnika),
  });
  // Vreme_pripreme: vremepripreme,
  _dodaj_multiprevod(recnik, {
    by: "virtel_key",
    virtel_key: "vremepripreme",
    value: virtel.vremepripreme,
    sasint_key: "Vreme_pripreme",
    sasint_value: _if_not_number_then_null(virtel.vremepripreme),
  });
  // Vreme_operacije: vremeoperacije,
  _dodaj_multiprevod(recnik, {
    by: "virtel_key",
    virtel_key: "vremeoperacije",
    value: virtel.vremeoperacije,
    sasint_key: "Vreme_operacije",
    sasint_value: _if_not_number_then_null(virtel.vremeoperacije),
  });
  // Vreme_ugradnje: vremeugradnje,
  _dodaj_multiprevod(recnik, {
    by: "virtel_key",
    virtel_key: "vremeugradnje",
    value: virtel.vremeugradnje,
    sasint_key: "Vreme_ugradnje",
    sasint_value: _if_not_number_then_null(virtel.vremeugradnje),
  });
  // Vreme_op_sklapanje: vremeopsklapanje,
  _dodaj_multiprevod(recnik, {
    by: "virtel_key",
    virtel_key: "vremeopsklapanje",
    value: virtel.vremeopsklapanje,
    sasint_key: "Vreme_op_sklapanje",
    sasint_value: _if_not_number_then_null(virtel.vremeopsklapanje),
  });
  // Stepen_slozenosti: stepenslozenosti,
  _dodaj_multiprevod(recnik, {
    by: "virtel_key",
    virtel_key: "stepenslozenosti",
    value: virtel.stepenslozenosti,
    sasint_key: "Stepen_slozenosti",
    sasint_value: _if_not_number_then_null(virtel.stepenslozenosti),
  });
  // Vreme_kumulativno: vremekumulativno,
  _dodaj_multiprevod(recnik, {
    by: "virtel_key",
    virtel_key: "vremekumulativno",
    value: virtel.vremekumulativno,
    sasint_key: "Vreme_kumulativno",
    sasint_value: _if_not_number_then_null(virtel.vremekumulativno),
  });
  // Kolicina_za_nalog: p.kolicina_za_nalog,
  _dodaj_multiprevod(recnik, {
    by: "virtel_key",
    virtel_key: "kolicina_za_nalog",
    value: virtel.kolicina_za_nalog,
    sasint_key: "Kolicina_za_nalog",
    sasint_value: _if_not_number_then_null(virtel.kolicina_za_nalog),
  });
  //
  // NOVA POLJA za CNC programe
  // Materijal: p.termaterijal, // NOVO,
  _dodaj_multiprevod(recnik, {
    by: "virtel_key",
    virtel_key: "termaterijal",
    value: virtel.termaterijal,
    sasint_key: "Materijal",
    sasint_value: virtel.termaterijal,
  });
  // _CNC_tip, // NOVO 2023-07-11
  // const _radni_centar = _getParamSingleFromSifrarnikRadnicentri(virtel.rc);
  let _CNC_tip = null;
  if (virtel.rc === "RCPRBS4" || virtel.rc === "RCLINS4P4") {
    _CNC_tip = "S4";
  }
  if (virtel.rc === "RCPRBAM") {
    _CNC_tip = "AMADA";
  }
  _dodaj_multiprevod(recnik, {
    by: "sasint_key", // samo u sastavnici
    // virtel_key: "",
    // value: ,
    sasint_key: "_CNC_tip",
    sasint_value: _CNC_tip,
  });
  //
  return recnik; // ne treba da returnuje nista jer on vec to upisuje u referencu na recnik
};


export const ter_prevodilac = {};


// ---------- v2 prevodilac u kojem nema kompleksnosti

const ter_recnik_kljuceva_maker = {};


//
export const _novi_prevodilac_testing = () => {
  //
  const recnik_entity = {
    virtel_key: "test",
    sasint_key: "Par22",
    cncvars_key: "$test$",
  };
  return recnik_entity;
};


//
const _dodaj_v2 = multitranslator_v2_dodaj_multiprevodJednogKljuca_u_recnikKljuceva;


//
// v2

ter_recnik_kljuceva_maker.terkk$klimakomora = (_virtel) => {
  // v2 pojednostavljeni recnik kljuceva koji moze biti dvosmeran
  //
  // recnik kljuceva
  const recnik = multitranslator_v2_napravi_novi_prazan_recnikKljuceva();
  //
  // staro iz ter-export-lib-sastavnica-21r3-element-lib
  let j = {};
  let p = {};
  let virtel = {}
  if (_virtel && _virtel.virtelschemakey) {
    p = _virtel;
    virtel = _virtel;
  }
  //
  const _sublang_klimakomora = [
    "terkk$klimakomora/klimakomora",
  ];
  //
  j.Par1 = p.nazivsistema;
  _dodaj_v2(recnik,
    "terkk$klimakomora",
    [
      ..._sublang_klimakomora,
    ], {
    by: "virtel_key",
    virtel_key: "nazivsistema",
    value: virtel.nazivsistema,
    sasint_key: "Par1",
    description: "Naziv sistema",
  });
  //
  j.Par2 = p.vrstaprofila;
  _dodaj_v2(recnik,
    "terkk$klimakomora",
    [
      ..._sublang_klimakomora,
    ], {
    by: "virtel_key",
    virtel_key: "vrstaprofila",
    value: virtel.vrstaprofila,
    sasint_key: "Par2",
    description: "Vrsta profila modula",
  });
  //
  j.Par3 = p.tipispuneklimakomore;
  _dodaj_v2(recnik,
    "terkk$klimakomora",
    [
      ..._sublang_klimakomora,
    ], {
    by: "virtel_key",
    virtel_key: "tipispuneklimakomore",
    value: virtel.tipispuneklimakomore,
    sasint_key: "Par3",
    description: "Tip ispune",
  });
  //
  j.Par4 = 'p.sirinakomoreoznaka + DOT + p.visinakomoreoznaka';
  /*
  _dodaj_v2(recnik,
    "terkk$klimakomora",
    [
      ..._sublang_klimakomora,
    ], {
    by: "virtel_key",
    virtel_key: "*Par4", //
    // value: virtel., // p.sirinakomoreoznaka + DOT + p.visinakomoreoznaka;
    sasint_key: "Par4",
  });
  */
  //
  j.Par5 = 'p.sirinakomore2oznaka + DOT + p.visinakomore2oznaka';
  /*
  _dodaj_v2(recnik,
    "terkk$klimakomora",
    [
      ..._sublang_klimakomora,
    ], {
    by: "virtel_key",
    virtel_key: "*Par5", //
    // value: virtel., // p.sirinakomore2oznaka + DOT + p.visinakomore2oznaka;
    sasint_key: "Par5",
  });
  */
  //
  j.Par19 = p.unutrasnjaoplata;
  _dodaj_v2(recnik,
    "terkk$klimakomora",
    [
      ..._sublang_klimakomora,
    ], {
    by: "virtel_key",
    virtel_key: "unutrasnjaoplata",
    value: virtel.unutrasnjaoplata,
    sasint_key: "Par19",
    description: "Unutrašnja oplata",
  });
  //
  const _ostali_Par = [
    "Par6",
    "Par7",
    "Par8",
    "Par9",
    "Par10",
    "Par11",
    // "Par12",
    // "Par13",
    "Par14",
    "Par15",
    "Par16",
    "Par17",
    "Par18",
    // j.Par19 = p.unutrasnjaoplata;
    "Par28",
    "Par29",
  ];
  _ostali_Par.forEach((_par_key) => {
    j[_par_key] = p[_par_key];
    _dodaj_v2(recnik,
      "terkk$klimakomora",
      [
        ..._sublang_klimakomora,
      ], {
      by: "virtel_key",
      virtel_key: _par_key,
      value: virtel[_par_key],
      sasint_key: _par_key,
      description: _par_key,
    });
  });
  //
  //
  // return j;
  return recnik;
};


ter_recnik_kljuceva_maker.terkk$modul = (_virtel) => {
  // v2 pojednostavljeni recnik kljuceva koji moze biti dvosmeran
  //
  // recnik kljuceva
  const recnik = multitranslator_v2_napravi_novi_prazan_recnikKljuceva();
  //
  // staro iz ter-export-lib-sastavnica-21r3-element-lib
  let j = {};
  let p = {};
  let virtel = {}
  if (_virtel && _virtel.virtelschemakey) {
    p = _virtel;
    virtel = _virtel;
  }
  //
  const _sublang_modul = [
    "terkk$modul/modul",
  ];
  //
  j.Par1 = p.msirinaspoljasnja;
  _dodaj_v2(recnik,
    "terkk$modul",
    [
      ..._sublang_modul,
    ], {
    by: "virtel_key",
    virtel_key: "msirinaspoljasnja",
    value: virtel.msirinaspoljasnja,
    sasint_key: "Par1",
    description: "Širina modula spoljašnja",
  });
  //
  j.Par2 = p.mvisinaspoljasnja;
  _dodaj_v2(recnik,
    "terkk$modul",
    [
      ..._sublang_modul,
    ], {
    by: "virtel_key",
    virtel_key: "mvisinaspoljasnja",
    value: virtel.mvisinaspoljasnja,
    sasint_key: "Par2",
    description: "Visina modula spoljašnja",
  });
  //
  j.Par3 = p.duzinamodula;
  _dodaj_v2(recnik,
    "terkk$modul",
    [
      ..._sublang_modul,
    ], {
    by: "virtel_key",
    virtel_key: "duzinamodula",
    value: virtel.duzinamodula,
    sasint_key: "Par3",
    description: "Dužina modula",
  });
  //
  j.Par4 = p.Par4;
  _dodaj_v2(recnik,
    "terkk$modul",
    [
      ..._sublang_modul,
    ], {
    by: "virtel_key",
    virtel_key: "Par4",
    value: virtel.Par4,
    sasint_key: "Par4",
    description: "Težina",
  });
  //
  j.Par5 = p.Par5;
  _dodaj_v2(recnik,
    "terkk$modul",
    [
      ..._sublang_modul,
    ], {
    by: "virtel_key",
    virtel_key: "Par5",
    value: virtel.Par5,
    sasint_key: "Par5",
    description: "Sastav sekcija",
  });
  //
  //
  // return j;
  return recnik;
};


ter_recnik_kljuceva_maker.terkk$grupa_profil = (_virtel) => {
  // v2 pojednostavljeni recnik kljuceva koji moze biti dvosmeran
  //
  // recnik kljuceva
  const recnik = multitranslator_v2_napravi_novi_prazan_recnikKljuceva();
  //
  // staro iz ter-export-lib-sastavnica-21r3-element-lib
  let j = {};
  let p = {};
  let virtel = {}
  if (_virtel && _virtel.virtelschemakey) {
    p = _virtel;
    virtel = _virtel;
  }
  //
  const _sublang_profil = [
    "terkk$grupa_profil/grupa_profil",
  ];
  //
  j.Par1 = p.duzina;
  _dodaj_v2(recnik,
    "terkk$grupa_profil",
    [
      ..._sublang_profil,
    ], {
    by: "virtel_key",
    virtel_key: "duzina",
    value: virtel.duzina,
    sasint_key: "Par1",
    description: "Dužina",
  });
  //
  j.Par2 = p.leviger;
  _dodaj_v2(recnik,
    "terkk$grupa_profil",
    [
      ..._sublang_profil,
    ], {
    by: "virtel_key",
    virtel_key: "leviger",
    value: virtel.leviger,
    sasint_key: "Par2",
    description: "Levi ger",
  });
  //
  j.Par3 = p.desniger;
  _dodaj_v2(recnik,
    "terkk$grupa_profil",
    [
      ..._sublang_profil,
    ], {
    by: "virtel_key",
    virtel_key: "desniger",
    value: virtel.desniger,
    sasint_key: "Par3",
    description: "Desni ger",
  });
  //
  // return j;
  return recnik;
};


ter_recnik_kljuceva_maker.terkk$grupa_ispuna = (_virtel) => {
  // v2 pojednostavljeni recnik kljuceva koji moze biti dvosmeran
  //
  // recnik kljuceva
  const recnik = multitranslator_v2_napravi_novi_prazan_recnikKljuceva();
  //
  // staro iz ter-export-lib-sastavnica-21r3-element-lib
  let j = {};
  let p = {};
  let virtel = {}
  if (_virtel && _virtel.virtelschemakey) {
    p = _virtel;
    virtel = _virtel;
  }
  //
  const _sublang_ispuna = [
    "terkk$grupa_ispuna/grupa_ispuna",
  ];
  //
  j.Par1 = p.sirina;
  _dodaj_v2(recnik,
    "terkk$grupa_ispuna",
    [
      ..._sublang_ispuna,
    ], {
    by: "virtel_key",
    virtel_key: "sirina",
    value: virtel.sirina,
    sasint_key: "Par1",
    description: "Širina",
  });
  //
  j.Par2 = p.visina;
  _dodaj_v2(recnik,
    "terkk$grupa_ispuna",
    [
      ..._sublang_ispuna,
    ], {
    by: "virtel_key",
    virtel_key: "visina",
    value: virtel.visina,
    sasint_key: "Par2",
    description: "Visina",
  });
  //
  // return j;
  return recnik;
};


ter_recnik_kljuceva_maker.terkk$ppv_sekcija = (_virtel) => {
  // v2 pojednostavljeni recnik kljuceva koji moze biti dvosmeran
  //
  // recnik kljuceva
  const recnik = multitranslator_v2_napravi_novi_prazan_recnikKljuceva();
  //
  // staro iz ter-export-lib-sastavnica-21r3-element-lib
  let j = {};
  let p = {};
  let virtel = {}
  if (_virtel && _virtel.virtelschemakey) {
    p = _virtel;
    virtel = _virtel;
  }
  // najpre dopunjavamo u renik default polja i prevode
  // _ter_prevodilac_dopuni_recnik_sa_default(recnik, virtel);
  //
  //
  // -----
  // PPV specificni
  /*
  "terkk$ppv_sekcija/OJACANJE_V",
  "terkk$ppv_sekcija/OJACANJE_H",
  "terkk$ppv_sekcija/OJACANJE_H",
  "terkk$ppv_sekcija/POKLOPCIC",
  */
  const _sublang_svi_1D_i_4D = [
    "terkk$ppv_sekcija/1D",
    "terkk$ppv_sekcija/4D_LEVO",
    "terkk$ppv_sekcija/4D_DOLE",
    "terkk$ppv_sekcija/4D_DESNO",
    "terkk$ppv_sekcija/4D_GORE",
  ];
  //
  // za sve osim ojacanja i poklopcica
  j.Par11 = p.ppv_o1; // Rastojanje izmedju otvora el veze
  _dodaj_v2(recnik,
    "terkk$ppv_sekcija",
    [
      "terkk$ppv/ppv",
      ..._sublang_svi_1D_i_4D
    ], {
    by: "virtel_key",
    virtel_key: "ppv_o1",
    value: virtel.ppv_o1, // Rastojanje izmedju otvora el veze
    sasint_key: "Par11",
    cncvars_key: "$O1$",
    // "description": "Dužina ojačanja-O1",
    "description": "Dužina ojačanja O1",
  });
  j.Par12 = p.ppv_o2; // Rastojanje otvora srednjih 12 otvora
  _dodaj_v2(recnik,
    "terkk$ppv_sekcija",
    [
      "terkk$ppv/ppv",
      ..._sublang_svi_1D_i_4D
    ], {
    by: "virtel_key",
    virtel_key: "ppv_o2",
    value: virtel.ppv_o2, // Rastojanje otvora srednjih 12 otvora
    sasint_key: "Par12",
    cncvars_key: "$O2$",
    // "description": "Dužina ojačanja-O2",
    "description": "Dužina ojačanja O2",
  });
  j.Par13 = p.ppv_kolikootvorazaelv;
  _dodaj_v2(recnik,
    "terkk$ppv_sekcija",
    [
      "terkk$ppv/ppv",
      ..._sublang_svi_1D_i_4D
    ], {
    by: "virtel_key",
    virtel_key: "ppv_kolikootvorazaelv",
    value: virtel.ppv_kolikootvorazaelv,
    sasint_key: "Par13",
    cncvars_key: "$BOEV$",
    "description": "Broj otvora za elastičnu vezu",
    // "description": "Broj otvora na elastičnoj vezi",
  });
  j.Par17 = p.ppv_medjuspoj_top;
  _dodaj_v2(recnik,
    "terkk$ppv_sekcija",
    [..._sublang_svi_1D_i_4D], {
    by: "virtel_key",
    virtel_key: "ppv_medjuspoj_top",
    value: virtel.ppv_medjuspoj_top,
    sasint_key: "Par17",
    cncvars_key: "$Spoj Limova Ventilatora Top$",
    "description": "Pozicija spoja delova PPV-a GORE",
  });
  j.Par18 = p.ppv_medjuspoj_bottom;
  _dodaj_v2(recnik,
    "terkk$ppv_sekcija",
    [..._sublang_svi_1D_i_4D], {
    by: "virtel_key",
    virtel_key: "ppv_medjuspoj_bottom",
    value: virtel.ppv_medjuspoj_bottom,
    sasint_key: "Par18",
    cncvars_key: "$Spoj Limova Ventilatora Bottom$",
    "description": "Pozicija spoja delova PPV-a DOLE",
  });

  j.Par19 = p.ppv_medjuspoj_left;
  _dodaj_v2(recnik,
    "terkk$ppv_sekcija",
    [..._sublang_svi_1D_i_4D], {
    by: "virtel_key",
    virtel_key: "ppv_medjuspoj_left",
    value: virtel.ppv_medjuspoj_left,
    sasint_key: "Par19",
    cncvars_key: "$Spoj Limova Ventilatora Left$",
    "description": "Pozicija spoja delova PPV-a LEVO",
  });
  j.Par20 = p.ppv_medjuspoj_right;
  _dodaj_v2(recnik,
    "terkk$ppv_sekcija",
    [..._sublang_svi_1D_i_4D], {
    by: "virtel_key",
    virtel_key: "ppv_medjuspoj_right",
    value: virtel.ppv_medjuspoj_right,
    sasint_key: "Par20",
    cncvars_key: "$Spoj Limova Ventilatora Right$",
    "description": "Pozicija spoja delova PPV-a DESNO",
  });
  /*
  j.Par21 = p.ppv_bezotvora;
  _dodaj_v2(recnik,
    "terkk$ppv_sekcija",
    [..._sublang_svi_1D_i_4D], {
    by: "virtel_key",
    virtel_key: "ppv_bezotvora",
    value: virtel.ppv_bezotvora,
    sasint_key: "Par21",
    cncvars_key: "$OTVOR$",
    "description": "Bez otvora",
  });
  */
  //
  // 
  j.Par1 = p.ppv_b; // sirina ppv-a
  _dodaj_v2(recnik,
    "terkk$ppv_sekcija",
    [
      "terkk$ppv/ppv",
      "terkk$ppv_sekcija/OJACANJE_H",
    ], {
    by: "virtel_key",
    virtel_key: "ppv_b",
    value: virtel.ppv_b, // sirina ppv-a
    sasint_key: "Par1",
    cncvars_key: "$B$",
    "description": "Širina sklopa PPV-parametar B",
  });
  j.Par2 = p.ppv_b1; // sirina od pocetka leve strane do rupe
  _dodaj_v2(recnik,
    "terkk$ppv_sekcija",
    [
      "terkk$ppv/ppv",
      "terkk$ppv_sekcija/1D",
      "terkk$ppv_sekcija/4D_LEVO",
    ], {
    by: "virtel_key",
    virtel_key: "ppv_b1",
    value: virtel.ppv_b1, // sirina od pocetka leve strane do rupe
    sasint_key: "Par2",
    cncvars_key: "$B1$",
    "description": "Širina levog dela PPV-parametar B1",
  });
  j.Par3 = p.ppv_b2; // dimenzija rupe
  _dodaj_v2(recnik,
    "terkk$ppv_sekcija",
    [
      "terkk$ppv/ppv",
      "terkk$ppv_sekcija/1D",
      "terkk$ppv_sekcija/4D_GORE",
      "terkk$ppv_sekcija/4D_DOLE",
      "terkk$ppv_sekcija/4D_LEVO",
      "terkk$ppv_sekcija/4D_DESNO",
    ], {
    by: "virtel_key",
    virtel_key: "ppv_b2",
    value: virtel.ppv_b2, // dimenzija rupe
    sasint_key: "Par3",
    cncvars_key: "$B2$",
    "description": "Širina srednjeg dela PPV-parametar B2",
  });
  j.Par4 = p.ppv_b3; // sirina od rupe do kraja desne strane
  _dodaj_v2(recnik,
    "terkk$ppv_sekcija",
    [
      "terkk$ppv/ppv",
      "terkk$ppv_sekcija/4D_DESNO",
    ], {
    by: "virtel_key",
    virtel_key: "ppv_b3",
    value: virtel.ppv_b3, // sirina od rupe do kraja desne strane
    sasint_key: "Par4",
    cncvars_key: "$B3$",
    "description": "Širina desnog dela PPV-parametar B3",
  });
  j.Par5 = p.ppv_b4; // sirina ppv sekcije
  _dodaj_v2(recnik,
    "terkk$ppv_sekcija",
    [
      "terkk$ppv/ppv",
      "terkk$ppv_sekcija/1D",
      "terkk$ppv_sekcija/OJACANJE_H",
    ], {
    by: "virtel_key",
    virtel_key: "ppv_b4",
    value: virtel.ppv_b4, // sirina ppv sekcije
    sasint_key: "Par5",
    cncvars_key: "$B4$",
    "description": "Širina podsklopa PPV-parametar B4",
  });
  j.Par6 = p.ppv_h; // visina ppv-a
  _dodaj_v2(recnik,
    "terkk$ppv_sekcija",
    [
      "terkk$ppv/ppv",
      "terkk$ppv_sekcija/OJACANJE_V",
    ], {
    by: "virtel_key",
    virtel_key: "ppv_h",
    value: virtel.ppv_h, // visina ppv-a
    sasint_key: "Par6",
    cncvars_key: "$H$",
    "description": "Visina sklopa PPV-parametar H",
  });
  j.Par7 = p.ppv_h1; // visina od dna sekcije do rupe
  _dodaj_v2(recnik,
    "terkk$ppv_sekcija",
    [
      "terkk$ppv/ppv",
      "terkk$ppv_sekcija/1D",
      "terkk$ppv_sekcija/4D_DOLE",
      "terkk$ppv_sekcija/4D_LEVO",
      "terkk$ppv_sekcija/4D_DESNO",
    ], {
    by: "virtel_key",
    virtel_key: "ppv_h1",
    value: virtel.ppv_h1, // visina od dna sekcije do rupe
    sasint_key: "Par7",
    cncvars_key: "$H1$",
    "description": "Visina do otvora za ventilator-parametar H1",
  });
  j.Par8 = p.ppv_h2; // dimenzija rupe
  _dodaj_v2(recnik,
    "terkk$ppv_sekcija",
    [
      "terkk$ppv/ppv",
      "terkk$ppv_sekcija/1D",
      "terkk$ppv_sekcija/4D_LEVO",
      "terkk$ppv_sekcija/4D_DESNO",
    ], {
    by: "virtel_key",
    virtel_key: "ppv_h2",
    value: virtel.ppv_h2, // dimenzija rupe
    sasint_key: "Par8",
    cncvars_key: "$H2$",
    "description": "Visina otvora za ventilator-parametar H2",
  });
  j.Par9 = p.ppv_h3; // visina iznad rupe do vrha sekcije
  _dodaj_v2(recnik,
    "terkk$ppv_sekcija",
    [
      "terkk$ppv/ppv",
      "terkk$ppv_sekcija/4D_GORE",
      "terkk$ppv_sekcija/4D_LEVO",
      "terkk$ppv_sekcija/4D_DESNO",
    ], {
    by: "virtel_key",
    virtel_key: "ppv_h3",
    value: virtel.ppv_h3, // visina iznad rupe do vrha sekcije
    sasint_key: "Par9",
    cncvars_key: "$H3$",
    "description": "Visina do otvora za ventilator-parametar H3",
  });
  j.Par10 = p.ppv_h4; // visina ppv sekcije
  _dodaj_v2(recnik,
    "terkk$ppv_sekcija",
    [
      "terkk$ppv/ppv",
      "terkk$ppv_sekcija/1D",
      "terkk$ppv_sekcija/4D_LEVO",
      "terkk$ppv_sekcija/4D_DESNO",
      "terkk$ppv_sekcija/OJACANJE_V",
    ], {
    by: "virtel_key",
    virtel_key: "ppv_h4",
    value: virtel.ppv_h4, // visina ppv sekcije
    sasint_key: "Par10",
    cncvars_key: "$H4$",
    "description": "Visina podsklopa PPV-parametar H4",
  });
  //
  //++++????
  j.Par15 = p.ppv_isojacanjapovisini;
  _dodaj_v2(recnik,
    "terkk$ppv_sekcija",
    [
      "terkk$ppv/ppv",
      "terkk$ppv_sekcija/1D",
      "terkk$ppv_sekcija/4D_LEVO",
      "terkk$ppv_sekcija/4D_DESNO",
    ], {
    by: "virtel_key",
    virtel_key: "ppv_isojacanjapovisini",
    value: virtel.ppv_isojacanjapovisini,
    sasint_key: "Par15",
    cncvars_key: "$ojv$",
    // "description": "Ojačanja DA/NE",
    "description": "Ojačanja po visini DA/NE",
  });
  j.Par16 = p.ppv_isojacanjaposirini;
  _dodaj_v2(recnik,
    "terkk$ppv_sekcija",
    [
      "terkk$ppv/ppv",
      "terkk$ppv_sekcija/1D",
      "terkk$ppv_sekcija/4D_GORE",
      "terkk$ppv_sekcija/4D_DOLE",
      "terkk$ppv_sekcija/4D_LEVO",
      "terkk$ppv_sekcija/4D_DESNO",
    ], {
    by: "virtel_key",
    virtel_key: "ppv_isojacanjaposirini",
    value: virtel.ppv_isojacanjaposirini,
    sasint_key: "Par16",
    cncvars_key: "$ojh$",
    "description": "Ojačanja po širini DA/NE",
  });
  j.Par21 = p.ppv_bezotvora; // NJ 2025-03-20
  _dodaj_v2(recnik,
    "terkk$ppv_sekcija",
    [
      "terkk$ppv_sekcija/1D",
    ], {
    by: "virtel_key",
    virtel_key: "ppv_bezotvora",
    value: virtel.ppv_bezotvora,
    sasint_key: "Par21",
    cncvars_key: "$BEZOTVORA$",
    "description": "Deo sa izostavljenim otvorom",
  });
  //
  //
  /*
  if (p.tip === "PPV_POKLOPCIC") {
    // TODO
    // lang: "terkk$ppv_sekcija/POKLOPCIC",
  }
  */
  //
  // ----- extra polja samo za cnc vars
  //...
  //
  // return j;
  return recnik;
};


ter_recnik_kljuceva_maker.terkk$ppvnosacv = (_virtel) => { // ppvnosacv Nosač ventilatora ???
  // v2 pojednostavljeni recnik kljuceva koji moze biti dvosmeran
  //
  // recnik kljuceva
  const recnik = multitranslator_v2_napravi_novi_prazan_recnikKljuceva();
  //
  // staro iz ter-export-lib-sastavnica-21r3-element-lib
  let j = {};
  let p = {};
  let virtel = {}
  if (_virtel && _virtel.virtelschemakey) {
    p = _virtel;
    virtel = _virtel;
  }
  //
  const _sublang_ppvnosacv = [
    "terkk$ppvnosacv/SKLOP_B",
    "terkk$ppvnosacv/LIM_OMEGA_A",
    "terkk$ppvnosacv/PROFIL_UNP_B",
    "terkk$ppvnosacv/UNP_MASKA",
  ];
  //
  j.Par30 = p.distinction_key;
  _dodaj_v2(recnik,
    "terkk$ppvnosacv",
    [
      "terkk$ppvnosacv/SKLOP_B",
      "terkk$ppvnosacv/LIM_OMEGA_A",
      "terkk$ppvnosacv/PROFIL_UNP_B",
      "terkk$ppvnosacv/UNP_MASKA",
    ], {
    by: "virtel_key",
    virtel_key: "distinction_key",
    value: virtel.distinction_key,
    sasint_key: "Par30",
    // cncvars_key: "",
    description: "distinction_key - preventuje isti ident čak i kad su svi ostali aprametri isti",
  });
  //
  j.Par1 = p.ppvnosacv_duzinanosacal;
  _dodaj_v2(recnik,
    "terkk$ppvnosacv",
    [
      "terkk$ppvnosacv/SKLOP_B",
      "terkk$ppvnosacv/LIM_OMEGA_A",
      "terkk$ppvnosacv/PROFIL_UNP_B",
      "terkk$ppvnosacv/UNP_MASKA",
    ], {
    by: "virtel_key",
    virtel_key: "ppvnosacv_duzinanosacal",
    value: virtel.ppvnosacv_duzinanosacal,
    sasint_key: "Par1",
    // cncvars_key: "",
    description: "Dužina profila",
  });
  //
  j.Par2 = p.ppvnosacv_precnikotvora;
  _dodaj_v2(recnik,
    "terkk$ppvnosacv",
    [
      "terkk$ppvnosacv/SKLOP_B",
      "terkk$ppvnosacv/LIM_OMEGA_A",
      "terkk$ppvnosacv/PROFIL_UNP_B",
      "terkk$ppvnosacv/UNP_MASKA",
    ], {
    by: "virtel_key",
    virtel_key: "ppvnosacv_precnikotvora",
    value: virtel.ppvnosacv_precnikotvora,
    sasint_key: "Par2",
    // cncvars_key: "",
    description: "Prečnik otvora",
  });
  //
  j.Par3 = p.ppvnosacv_l1;
  _dodaj_v2(recnik,
    "terkk$ppvnosacv",
    [
      "terkk$ppvnosacv/SKLOP_B",
      "terkk$ppvnosacv/LIM_OMEGA_A",
      "terkk$ppvnosacv/PROFIL_UNP_B",
      "terkk$ppvnosacv/UNP_MASKA",
    ], {
    by: "virtel_key",
    virtel_key: "ppvnosacv_l1",
    value: virtel.ppvnosacv_l1,
    sasint_key: "Par3",
    // cncvars_key: "",
    description: "L1",
  });
  //
  j.Par4 = p.ppvnosacv_l2;
  _dodaj_v2(recnik,
    "terkk$ppvnosacv",
    [
      "terkk$ppvnosacv/SKLOP_B",
      "terkk$ppvnosacv/LIM_OMEGA_A",
      "terkk$ppvnosacv/PROFIL_UNP_B",
      "terkk$ppvnosacv/UNP_MASKA",
    ], {
    by: "virtel_key",
    virtel_key: "ppvnosacv_l2",
    value: virtel.ppvnosacv_l2,
    sasint_key: "Par4",
    // cncvars_key: "",
    description: "L2",
  });
  //
  j.Par5 = p.ppvnosacv_l3;
  _dodaj_v2(recnik,
    "terkk$ppvnosacv",
    [
      "terkk$ppvnosacv/SKLOP_B",
      "terkk$ppvnosacv/LIM_OMEGA_A",
      "terkk$ppvnosacv/PROFIL_UNP_B",
      "terkk$ppvnosacv/UNP_MASKA",
    ], {
    by: "virtel_key",
    virtel_key: "ppvnosacv_l3",
    value: virtel.ppvnosacv_l3,
    sasint_key: "Par5",
    // cncvars_key: "",
    description: "L3",
  });
  //
  j.Par6 = p.ppvnosacv_brojventilatoraponosacu;
  _dodaj_v2(recnik,
    "terkk$ppvnosacv",
    [
      "terkk$ppvnosacv/SKLOP_B",
      "terkk$ppvnosacv/LIM_OMEGA_A",
      "terkk$ppvnosacv/PROFIL_UNP_B",
      "terkk$ppvnosacv/UNP_MASKA",
    ], {
    by: "virtel_key",
    virtel_key: "ppvnosacv_brojventilatoraponosacu",
    value: virtel.ppvnosacv_brojventilatoraponosacu,
    sasint_key: "Par6",
    // cncvars_key: "",
    description: "Broj ventilatora po nosaču",
  });
  //
  j.Par7 = p.ppvnosacv_unpmaska;
  _dodaj_v2(recnik,
    "terkk$ppvnosacv",
    [
      "terkk$ppvnosacv/SKLOP_B",
    ], {
    by: "virtel_key",
    virtel_key: "ppvnosacv_unpmaska",
    value: virtel.ppvnosacv_unpmaska,
    sasint_key: "Par7",
    // cncvars_key: "",
    description: "UNP Maska DA/NE",
  });
  //
  // return j;
  return recnik;
};


ter_recnik_kljuceva_maker.terkk$postolje = (_virtel) => {
  // v2 pojednostavljeni recnik kljuceva koji moze biti dvosmeran
  //
  // recnik kljuceva
  const recnik = multitranslator_v2_napravi_novi_prazan_recnikKljuceva();
  //
  // staro iz ter-export-lib-sastavnica-21r3-element-lib
  let j = {};
  let p = {};
  let virtel = {}
  if (_virtel && _virtel.virtelschemakey) {
    p = _virtel;
    virtel = _virtel;
  }
  //
  j.Par1 = p.duzinapostolja; //
  _dodaj_v2(recnik,
    "terkk$postolje",
    [
      "terkk$postolje/postolje",
    ], {
    by: "virtel_key",
    virtel_key: "duzinapostolja",
    value: virtel.duzinapostolja, //
    sasint_key: "Par1",
    // cncvars_key: "",
    "description": "Dužina postolja",
  });
  j.Par2 = p.sirinapostolja; //
  _dodaj_v2(recnik,
    "terkk$postolje",
    [
      "terkk$postolje/postolje",
    ], {
    by: "virtel_key",
    virtel_key: "sirinapostolja",
    value: virtel.sirinapostolja, //
    sasint_key: "Par2",
    // cncvars_key: "",
    "description": "Širina postolja",
  });
  j.Par3 = p.visinapostolja; //
  _dodaj_v2(recnik,
    "terkk$postolje",
    [
      "terkk$postolje/postolje",
      "terkk$postolje/postolje_profil",
    ], {
    by: "virtel_key",
    virtel_key: "visinapostolja",
    value: virtel.visinapostolja, //
    sasint_key: "Par3",
    cncvars_key: "$y$",
    "description": "Visina postolja",
  });
  j.Par4 = p.sirinaprofilapostolja; //
  _dodaj_v2(recnik,
    "terkk$postolje",
    [
      "terkk$postolje/postolje",
      "terkk$postolje/postolje_profil",
    ], {
    by: "virtel_key",
    virtel_key: "sirinaprofilapostolja",
    value: virtel.sirinaprofilapostolja, //
    sasint_key: "Par4",
    // cncvars_key: "",
    "description": "Širina profila postolja",
    // "description": "Širina profila za postolja",
  });
  j.Par5 = p.duzina; // duzina profila postolja
  _dodaj_v2(recnik,
    "terkk$postolje",
    [
      "terkk$postolje/postolje_profil",
    ], {
    by: "virtel_key",
    virtel_key: "duzina",
    value: virtel.duzina, //
    sasint_key: "Par5",
    cncvars_key: "$x$",
    // "description": "Dužina",
    "description": "Dužina postolja",
  });
  //
  j.Par6 = p.pozicijaojacanja_poduzini_pack; //
  _dodaj_v2(recnik,
    "terkk$postolje",
    [
      "terkk$postolje/postolje",
    ], {
    by: "virtel_key",
    virtel_key: "pozicijaojacanja_poduzini_pack",
    value: virtel.pozicijaojacanja_poduzini_pack, //
    sasint_key: "Par6",
    // cncvars_key: "",
    // "description": "Pozicija ojačanja",
    // "description": "Pozicija ojačanja po dužini",
    "description": "Pozicije ojačanja po dužini",
  });
  j.Par7 = p.pozicijaojacanja_posirini_pack; //
  _dodaj_v2(recnik,
    "terkk$postolje",
    [
      "terkk$postolje/postolje",
    ], {
    by: "virtel_key",
    virtel_key: "pozicijaojacanja_posirini_pack",
    value: virtel.pozicijaojacanja_posirini_pack, //
    sasint_key: "Par7",
    // cncvars_key: "",
    // "description": "Pozicija ojačanja po širini",
    "description": "Pozicije ojačanja po širini",
  });
  j.Par8 = p.pozicijaodvodakondenzata_pack; //
  _dodaj_v2(recnik,
    "terkk$postolje",
    [
      "terkk$postolje/postolje",
    ], {
    by: "virtel_key",
    virtel_key: "pozicijaodvodakondenzata_pack",
    value: virtel.pozicijaodvodakondenzata_pack, //
    sasint_key: "Par8",
    // cncvars_key: "",
    // "description": "Pozicija za odvod kondenzata",
    // "description": "Pozicija odvoda za kondenzat",
    "description": "Pozicije odvoda za kondenzat",
  });
  //
  j.Par9 = p.pozicijaojacanja1; //
  _dodaj_v2(recnik,
    "terkk$postolje",
    [
      "terkk$postolje/postolje_profil",
    ], {
    by: "virtel_key",
    virtel_key: "pozicijaojacanja1",
    value: virtel.pozicijaojacanja1, //
    sasint_key: "Par9",
    cncvars_key: "$Pozicija ojacanja 1S$",
    "description": "Pozicija prvog ojačanja",
  });
  j.Par10 = p.pozicijaojacanja2; //
  _dodaj_v2(recnik,
    "terkk$postolje",
    [
      "terkk$postolje/postolje_profil",
    ], {
    by: "virtel_key",
    virtel_key: "pozicijaojacanja2",
    value: virtel.pozicijaojacanja2, //
    sasint_key: "Par10",
    cncvars_key: "$Pozicija ojacanja 2S$",
    "description": "Pozicija drugog ojačanja",
  });
  j.Par11 = p.pozicijaojacanja3; //
  _dodaj_v2(recnik,
    "terkk$postolje",
    [
      "terkk$postolje/postolje_profil",
    ], {
    by: "virtel_key",
    virtel_key: "pozicijaojacanja3",
    value: virtel.pozicijaojacanja3, //
    sasint_key: "Par11",
    cncvars_key: "$Pozicija ojacanja 3S$",
    "description": "Pozicija trećeg ojačanja",
  });
  j.Par12 = p.pozicijaojacanja4; //
  _dodaj_v2(recnik,
    "terkk$postolje",
    [
      "terkk$postolje/postolje_profil",
    ], {
    by: "virtel_key",
    virtel_key: "pozicijaojacanja4",
    value: virtel.pozicijaojacanja4, //
    sasint_key: "Par12",
    cncvars_key: "$Pozicija ojacanja 4S$",
    "description": "Pozicija četvrtog ojačanja",
  });
  //
  j.Par19 = p.pozicijaodvodakondenzata1; //
  _dodaj_v2(recnik,
    "terkk$postolje",
    [
      "terkk$postolje/postolje_profil",
    ], {
    by: "virtel_key",
    virtel_key: "pozicijaodvodakondenzata1",
    value: virtel.pozicijaodvodakondenzata1, //
    sasint_key: "Par19",
    cncvars_key: "$Pozicija 1O$",
    "description": "Pozicija prvog odvoda za kondenzat",
  });
  j.Par20 = p.pozicijaodvodakondenzata2; //
  _dodaj_v2(recnik,
    "terkk$postolje",
    [
      "terkk$postolje/postolje_profil",
    ], {
    by: "virtel_key",
    virtel_key: "pozicijaodvodakondenzata2",
    value: virtel.pozicijaodvodakondenzata2, //
    sasint_key: "Par20",
    cncvars_key: "$Pozicija 2O$",
    "description": "Pozicija drugog odvoda za kondenzat",
  });
  j.Par21 = p.pozicijaodvodakondenzata3; //
  _dodaj_v2(recnik,
    "terkk$postolje",
    [
      "terkk$postolje/postolje_profil",
    ], {
    by: "virtel_key",
    virtel_key: "pozicijaodvodakondenzata3",
    value: virtel.pozicijaodvodakondenzata3, //
    sasint_key: "Par21",
    cncvars_key: "$Pozicija 3O$",
    "description": "Pozicija trećeg odvoda za kondenzat",
  });
  //
  return recnik;
};


ter_recnik_kljuceva_maker.terkk$kadica = (_virtel) => { // prigusivac buke
  // v2 pojednostavljeni recnik kljuceva koji moze biti dvosmeran
  //
  // recnik kljuceva
  const recnik = multitranslator_v2_napravi_novi_prazan_recnikKljuceva();
  //
  // staro iz ter-export-lib-sastavnica-21r3-element-lib
  let j = {};
  let p = {};
  let virtel = {}
  if (_virtel && _virtel.virtelschemakey) {
    p = _virtel;
    virtel = _virtel;
  }
  //
  const _sublang_kadica = [
    "terkk$kadica/SKLOP_KADICA",
    "terkk$kadica/LIM",
  ];
  //
  j.Par1 = p.duzina;
  _dodaj_v2(recnik,
    "terkk$kadica",
    [
      "terkk$kadica/SKLOP_KADICA",
      "terkk$kadica/LIM",
    ], {
    by: "virtel_key",
    virtel_key: "duzina",
    value: virtel.duzina,
    sasint_key: "Par1",
    cncvars_key: "$duzina$",
    description: "Dužina",
  });
  //
  j.Par2 = p.sirina;
  _dodaj_v2(recnik,
    "terkk$kadica",
    [
      "terkk$kadica/SKLOP_KADICA",
      "terkk$kadica/LIM",
    ], {
    by: "virtel_key",
    virtel_key: "sirina",
    value: virtel.sirina,
    sasint_key: "Par2",
    cncvars_key: "$sirina$",
    description: "Širina",
  });
  //
  j.Par3 = p.odvodkondenzata;
  _dodaj_v2(recnik,
    "terkk$kadica",
    [
      "terkk$kadica/SKLOP_KADICA",
      "terkk$kadica/LIM",
    ], {
    by: "virtel_key",
    virtel_key: "odvodkondenzata",
    value: virtel.odvodkondenzata,
    sasint_key: "Par3",
    cncvars_key: "$odvodkondenzata$",
    description: "Odvod kondenzata",
  });
  j.Par4 = p.ter_koji_deo_visedelnog; //
  _dodaj_v2(recnik,
    "terkk$kadica",
    [
      "terkk$kadica/SKLOP_KADICA",
      "terkk$kadica/LIM",
    ], {
    by: "virtel_key",
    virtel_key: "ter_koji_deo_visedelnog",
    value: virtel.ter_koji_deo_visedelnog,
    sasint_key: "Par4",
    description: "Koji deo od višedelnog",
  });
  j.Par5 = p.ter_visedelni_koliko_delova; //
  _dodaj_v2(recnik,
    "terkk$kadica",
    [
      "terkk$kadica/SKLOP_KADICA",
    ], {
    by: "virtel_key",
    virtel_key: "ter_visedelni_koliko_delova",
    value: virtel.ter_visedelni_koliko_delova,
    sasint_key: "Par5",
    description: "Višpedelni sa koliko delova",
  });
  //
  // return j;
  return recnik;
};


ter_recnik_kljuceva_maker.terkk$krov = (_virtel) => { // KROV
  // v2 pojednostavljeni recnik kljuceva koji moze biti dvosmeran
  //
  // recnik kljuceva
  const recnik = multitranslator_v2_napravi_novi_prazan_recnikKljuceva();
  //
  // staro iz ter-export-lib-sastavnica-21r3-element-lib
  let j = {};
  let p = {};
  let virtel = {}
  if (_virtel && _virtel.virtelschemakey) {
    p = _virtel;
    virtel = _virtel;
  }
  //
  const _sublang_krov_abcde = [
    "terkk$krov/child_abcde",
  ];
  //
  j.Par1 = p.duzina; //
  _dodaj_v2(recnik,
    "terkk$krov",
    [
      ..._sublang_krov_abcde,
      "terkk$krov/snala",
    ], {
    by: "virtel_key",
    virtel_key: "duzina",
    value: virtel.duzina, //
    sasint_key: "Par1",
    cncvars_key: "$duzina$",
    // "description": "Dužina krova",
    // "description": "Dužina šnale",
    "description": "Dužina",
  });
  j.Par2 = p.sirina; //
  _dodaj_v2(recnik,
    "terkk$krov",
    [
      ..._sublang_krov_abcde,
    ], {
    by: "virtel_key",
    virtel_key: "sirina",
    value: virtel.sirina, //
    sasint_key: "Par2",
    cncvars_key: "$sirina$",
    "description": "Širina krova",
  });
  j.Par3 = p.krovniotvor; //
  _dodaj_v2(recnik,
    "terkk$krov",
    [
      ..._sublang_krov_abcde,
    ], {
    by: "virtel_key",
    virtel_key: "krovniotvor",
    value: virtel.krovniotvor, //
    sasint_key: "Par3",
    cncvars_key: "$krovniotvor$",
    "description": "Otvor na krovu DA/NE",
  });
  //
  j.Par4 = p.a; //
  _dodaj_v2(recnik,
    "terkk$krov",
    [
      ..._sublang_krov_abcde,
    ], {
    by: "virtel_key",
    virtel_key: "a",
    value: virtel.a, //
    sasint_key: "Par4",
    cncvars_key: "$a$",
    "description": "Otvor na krovu Parametar A",
  });
  j.Par5 = p.b; //
  _dodaj_v2(recnik,
    "terkk$krov",
    [
      ..._sublang_krov_abcde,
    ], {
    by: "virtel_key",
    virtel_key: "b",
    value: virtel.b, //
    sasint_key: "Par5",
    cncvars_key: "$b$",
    "description": "Otvor na krovu Parametar B",
  });
  j.Par6 = p.x; //
  _dodaj_v2(recnik,
    "terkk$krov",
    [
      ..._sublang_krov_abcde,
    ], {
    by: "virtel_key",
    virtel_key: "x",
    value: virtel.x, //
    sasint_key: "Par6",
    cncvars_key: "$x$",
    "description": "Otvor na krovu Parametar X",
  });
  j.Par7 = p.y; //
  _dodaj_v2(recnik,
    "terkk$krov",
    [
      ..._sublang_krov_abcde,
    ], {
    by: "virtel_key",
    virtel_key: "y",
    value: virtel.y, //
    sasint_key: "Par7",
    cncvars_key: "$y$",
    "description": "Otvor na krovu Parametar Y",
  });
  //
  return recnik;
};


ter_recnik_kljuceva_maker.terkk$klizac = (_virtel) => { // KLI
  // v2 pojednostavljeni recnik kljuceva koji moze biti dvosmeran
  //
  // recnik kljuceva
  const recnik = multitranslator_v2_napravi_novi_prazan_recnikKljuceva();
  //
  // staro iz ter-export-lib-sastavnica-21r3-element-lib
  let j = {};
  let p = {};
  let virtel = {}
  if (_virtel && _virtel.virtelschemakey) {
    p = _virtel;
    virtel = _virtel;
  }
  //
  const _sublang_klizac = [
    /*
    "terkk$klizac/SKLOP_KLIZAC",
    "terkk$klizac/LIM_OMEGA",
    "terkk$klizac/LIM_L",
    "terkk$klizac/MASKA",
    "terkk$klizac/PLOCICA",
    */
  ];
  //
  /*
  - MASKA parametri duzina, visina klizaca (20 ili 35), tip kadice standardna ili plitka tip klizaca (B ili C), da li je maska dvodelna ili jednodelna odnosno nekkav broj dela da bude 1 ako je prvo deo a 2 ako je drugi deo a nista null ako je jednodelna BROJ DELA U SLUCAJU VISEDELNE
  */
  j.Par1 = p.duzina; //
  _dodaj_v2(recnik,
    "terkk$klizac",
    [
      "terkk$klizac/SKLOP_KLIZAC",
      "terkk$klizac/LIM_OMEGA",
      "terkk$klizac/LIM_L",
      "terkk$klizac/MASKA",
      "terkk$klizac/PLOCICA",
    ], {
    by: "virtel_key",
    virtel_key: "duzina",
    value: virtel.duzina,
    sasint_key: "Par1",
    description: "Dužina",
  });
  //
  j.Par2 = p.visina; //
  _dodaj_v2(recnik,
    "terkk$klizac",
    [
      // "terkk$klizac/SKLOP_KLIZAC",
      // "terkk$klizac/LIM_OMEGA",
      // "terkk$klizac/MASKA",
      "terkk$klizac/PLOCICA",
    ], {
    by: "virtel_key",
    virtel_key: "visina",
    value: virtel.visina,
    sasint_key: "Par2",
    description: "Visina",
  });
  //
  /*
  j.Par3 = p.klizac_tip; //
  _dodaj_v2(recnik,
    "terkk$klizac",
    [
      // "terkk$klizac/SKLOP_KLIZAC",
      // "terkk$klizac/LIM_L",
      // "terkk$klizac/LIM_OMEGA",
      // "terkk$klizac/MASKA",
    ], {
    by: "virtel_key",
    virtel_key: "klizac_tip",
    value: virtel.klizac_tip,
    sasint_key: "Par3",
    description: "Tip klizača",
  });
  */
  //
  /*
  j.Par4 = p.klizac_tip_kadice; //
  _dodaj_v2(recnik,
    "terkk$klizac",
    [
      // "terkk$klizac/SKLOP_KLIZAC",
      // "terkk$klizac/MASKA",
    ], {
    by: "virtel_key",
    virtel_key: "klizac_tip_kadice",
    value: virtel.klizac_tip_kadice,
    sasint_key: "Par4",
    description: "Tip kadice",
  });
  */
  //
  j.Par3 = p.klizac_strana_maske; //
  _dodaj_v2(recnik,
    "terkk$klizac",
    [
      // "terkk$klizac/SKLOP_KLIZAC",
    ], {
    by: "virtel_key",
    virtel_key: "klizac_strana_maske",
    value: virtel.klizac_strana_maske,
    sasint_key: "Par3",
    description: "Strana maske",
  });
  //
  j.Par4 = p.ter_koji_deo_visedelnog; //
  _dodaj_v2(recnik,
    "terkk$klizac",
    [
      "terkk$klizac/MASKA",
    ], {
    by: "virtel_key",
    virtel_key: "ter_koji_deo_visedelnog",
    value: virtel.ter_koji_deo_visedelnog,
    sasint_key: "Par4",
    description: "Koji deo od višedelnog",
  });
  //
  j.Par5 = p.tipkomore; //
  _dodaj_v2(recnik,
    "terkk$klizac",
    [
      "terkk$klizac/SKLOP_KLIZAC",
    ], {
    by: "virtel_key",
    virtel_key: "tipkomore",
    value: virtel.tipkomore,
    sasint_key: "Par5",
    description: "Tip komore",
  });
  //
  // return j;
  return recnik;
};


ter_recnik_kljuceva_maker.terkk$kelg = (_virtel) => { // NPR
  // v2 pojednostavljeni recnik kljuceva koji moze biti dvosmeran
  //
  // recnik kljuceva
  const recnik = multitranslator_v2_napravi_novi_prazan_recnikKljuceva();
  //
  // staro iz ter-export-lib-sastavnica-21r3-element-lib
  let j = {};
  let p = {};
  let virtel = {}
  if (_virtel && _virtel.virtelschemakey) {
    p = _virtel;
    virtel = _virtel;
  }
  //
  const _sublang_kelg = [
    "terkk$kelg/SKLOP_KELG",
    "terkk$kelg/P12",
    "terkk$kelg/P34",
    "terkk$kelg/P5",
  ];
  //
  j.Par30 = p.distinction_key;
  _dodaj_v2(recnik,
    "terkk$kelg",
    [
      "terkk$kelg/SKLOP_KELG",
      "terkk$kelg/P12",
      "terkk$kelg/P34",
      "terkk$kelg/P5",
    ], {
    by: "virtel_key",
    virtel_key: "distinction_key",
    value: virtel.distinction_key,
    sasint_key: "Par30",
    // cncvars_key: "",
    description: "distinction_key - preventuje isti ident čak i kad su svi ostali aprametri isti",
  });
  //
  j.Par1 = p.duzina;
  _dodaj_v2(recnik,
    "terkk$kelg",
    [
      "terkk$kelg/SKLOP_KELG",
      "terkk$kelg/P34",
      "terkk$kelg/P5",
    ], {
    by: "virtel_key",
    virtel_key: "duzina",
    value: virtel.duzina,
    sasint_key: "Par1",
    // cncvars_key: "",
    description: "Dužina",
  });
  //
  j.Par2 = p.visina;
  _dodaj_v2(recnik,
    "terkk$kelg",
    [
      "terkk$kelg/SKLOP_KELG",
      "terkk$kelg/P12",
      "terkk$kelg/P5",
    ], {
    by: "virtel_key",
    virtel_key: "visina",
    value: virtel.visina,
    sasint_key: "Par2",
    // cncvars_key: "",
    description: "Visina",
  });
  //
  j.Par3 = p.sirina;
  _dodaj_v2(recnik,
    "terkk$kelg",
    [
      "terkk$kelg/SKLOP_KELG",
      "terkk$kelg/P12",
      "terkk$kelg/P34",
      "terkk$kelg/P5",
    ], {
    by: "virtel_key",
    virtel_key: "sirina",
    value: virtel.sirina,
    sasint_key: "Par3",
    // cncvars_key: "",
    description: "Širina",
  });
  //
  j.Par4 = p.kelg_kolikoredova;
  _dodaj_v2(recnik,
    "terkk$kelg",
    [
      "terkk$kelg/SKLOP_KELG",
      "terkk$kelg/P12",
      "terkk$kelg/P34",
      "terkk$kelg/P5",
    ], {
    by: "virtel_key",
    virtel_key: "kelg_kolikoredova",
    value: virtel.kelg_kolikoredova,
    sasint_key: "Par4",
    // cncvars_key: "",
    description: "Broj redova",
  });
  //
  j.Par5 = p.kelg_kolikogrejacapovisini;
  _dodaj_v2(recnik,
    "terkk$kelg",
    [
      "terkk$kelg/SKLOP_KELG",
      "terkk$kelg/P12",
      "terkk$kelg/P34",
      "terkk$kelg/P5",
    ], {
    by: "virtel_key",
    virtel_key: "kelg_kolikogrejacapovisini",
    value: virtel.kelg_kolikogrejacapovisini,
    sasint_key: "Par5",
    // cncvars_key: "",
    description: "Broj grejača po visini",
  });
  //
  j.Par6 = p.kelg_rak_termostat;
  _dodaj_v2(recnik,
    "terkk$kelg",
    [
      "terkk$kelg/SKLOP_KELG",
      "terkk$kelg/P12",
      "terkk$kelg/P34",
      "terkk$kelg/P5",
    ], {
    by: "virtel_key",
    virtel_key: "kelg_rak_termostat",
    value: virtel.kelg_rak_termostat,
    sasint_key: "Par6",
    // cncvars_key: "",
    description: "RAK termostat",
  });
  //
  // return j;
  return recnik;
};


ter_recnik_kljuceva_maker.terkk$npr = (_virtel) => { // NPR
  // v2 pojednostavljeni recnik kljuceva koji moze biti dvosmeran
  //
  // recnik kljuceva
  const recnik = multitranslator_v2_napravi_novi_prazan_recnikKljuceva();
  //
  // staro iz ter-export-lib-sastavnica-21r3-element-lib
  let j = {};
  let p = {};
  let virtel = {}
  if (_virtel && _virtel.virtelschemakey) {
    p = _virtel;
    virtel = _virtel;
  }
  //
  const _sublang_npr = [
    "terkk$npr/SKLOP_NPR",
    "terkk$npr/SKLOP_NPR_POSTOLJE",
    "terkk$npr/AB",
  ];
  //
  j.Par30 = p.distinction_key;
  _dodaj_v2(recnik,
    "terkk$npr",
    [
      "terkk$npr/SKLOP_NPR",
      "terkk$npr/SKLOP_NPR_POSTOLJE",
      "terkk$npr/AB",
    ], {
    by: "virtel_key",
    virtel_key: "distinction_key",
    value: virtel.distinction_key,
    sasint_key: "Par30",
    // cncvars_key: "",
    description: "distinction_key - preventuje isti ident čak i kad su svi ostali aprametri isti",
  });
  //
  j.Par1 = p.dimenzija1;
  _dodaj_v2(recnik,
    "terkk$npr",
    [
      "terkk$npr/SKLOP_NPR",
      "terkk$npr/AB",
    ], {
    by: "virtel_key",
    virtel_key: "dimenzija1",
    value: virtel.dimenzija1,
    sasint_key: "Par1",
    // cncvars_key: "$sirina$",
    description: "dimenzija1",
  });
  //
  j.Par2 = p.dimenzija2;
  _dodaj_v2(recnik,
    "terkk$npr",
    [
      "terkk$npr/SKLOP_NPR",
      "terkk$npr/AB",
    ], {
    by: "virtel_key",
    virtel_key: "dimenzija2",
    value: virtel.dimenzija2,
    sasint_key: "Par2",
    // cncvars_key: "$sirina$",
    description: "dimenzija2",
  });
  //
  j.Par3 = p.npr_tipkomore;
  _dodaj_v2(recnik,
    "terkk$npr",
    [
      "terkk$npr/SKLOP_NPR",
    ], {
    by: "virtel_key",
    virtel_key: "npr_tipkomore",
    value: virtel.npr_tipkomore,
    sasint_key: "Par3",
    description: "npr_tipkomore",
  });

  //
  j.Par4 = p.npr_sirinakomore;
  _dodaj_v2(recnik,
    "terkk$npr",
    [
      "terkk$npr/SKLOP_NPR",
    ], {
    by: "virtel_key",
    virtel_key: "npr_sirinakomore",
    value: virtel.npr_sirinakomore,
    sasint_key: "Par4",
    description: "npr_sirinakomore",
  });
  //
  j.Par5 = p.npr_visinadonjesekcije;
  _dodaj_v2(recnik,
    "terkk$npr",
    [
      "terkk$npr/SKLOP_NPR",
    ], {
    by: "virtel_key",
    virtel_key: "npr_visinadonjesekcije",
    value: virtel.npr_visinadonjesekcije,
    sasint_key: "Par5",
    description: "npr_visinadonjesekcije",
  });
  //
  j.Par6 = p.npr_visinagornjesekcije;
  _dodaj_v2(recnik,
    "terkk$npr",
    [
      "terkk$npr/SKLOP_NPR",
    ], {
    by: "virtel_key",
    virtel_key: "npr_visinagornjesekcije",
    value: virtel.npr_visinagornjesekcije,
    sasint_key: "Par6",
    description: "npr_visinagornjesekcije",
  });

  //
  j.Par7 = p.npr_visinakomore;
  _dodaj_v2(recnik,
    "terkk$npr",
    [
      "terkk$npr/SKLOP_NPR",
    ], {
    by: "virtel_key",
    virtel_key: "npr_visinakomore",
    value: virtel.npr_visinakomore,
    sasint_key: "Par7",
    description: "npr_visinakomore",
  });
  //
  j.Par8 = p.npr_sirinaprednjesekcije;
  _dodaj_v2(recnik,
    "terkk$npr",
    [
      "terkk$npr/SKLOP_NPR",
    ], {
    by: "virtel_key",
    virtel_key: "npr_sirinaprednjesekcije",
    value: virtel.npr_sirinaprednjesekcije,
    sasint_key: "Par8",
    description: "npr_sirinaprednjesekcije",
  });
  //
  j.Par9 = p.npr_sirinazadnjesekcije;
  _dodaj_v2(recnik,
    "terkk$npr",
    [
      "terkk$npr/SKLOP_NPR",
    ], {
    by: "virtel_key",
    virtel_key: "npr_sirinazadnjesekcije",
    value: virtel.npr_sirinazadnjesekcije,
    sasint_key: "Par9",
    description: "npr_sirinazadnjesekcije",
  });

  //
  j.Par10 = p.npr_brojmodula;
  _dodaj_v2(recnik,
    "terkk$npr",
    [
      "terkk$npr/SKLOP_NPR",
    ], {
    by: "virtel_key",
    virtel_key: "npr_brojmodula",
    value: virtel.npr_brojmodula,
    sasint_key: "Par10",
    description: "npr_brojmodula",
  });
  //
  j.Par11 = p.npr_stranicarekuperatora;
  _dodaj_v2(recnik,
    "terkk$npr",
    [
      "terkk$npr/SKLOP_NPR",
      "terkk$npr/SKLOP_NPR_POSTOLJE",
    ], {
    by: "virtel_key",
    virtel_key: "npr_stranicarekuperatora",
    value: virtel.npr_stranicarekuperatora,
    sasint_key: "Par11",
    description: "npr_stranicarekuperatora",
  });
  //
  j.Par12 = p.npr_demperbypass;
  _dodaj_v2(recnik,
    "terkk$npr",
    [
      "terkk$npr/SKLOP_NPR",
    ], {
    by: "virtel_key",
    virtel_key: "npr_demperbypass",
    value: virtel.npr_demperbypass,
    sasint_key: "Par12",
    description: "npr_demperbypass",
  });
  //
  j.Par13 = p.duzinamodula;
  _dodaj_v2(recnik,
    "terkk$npr",
    [
      "terkk$npr/SKLOP_NPR",
    ], {
    by: "virtel_key",
    virtel_key: "duzinamodula",
    value: virtel.duzinamodula,
    sasint_key: "Par13",
    description: "duzinamodula",
  });
  //
  j.Par14 = p.tervrstaprofila_50_ili_70;
  _dodaj_v2(recnik,
    "terkk$npr",
    [
      "terkk$npr/SKLOP_NPR",
    ], {
    by: "virtel_key",
    virtel_key: "tervrstaprofila_50_ili_70",
    value: virtel.tervrstaprofila_50_ili_70,
    sasint_key: "Par14",
    description: "tervrstaprofila_50_ili_70",
  });
  //
  // return j;
  return recnik;
};


ter_recnik_kljuceva_maker.terkk$nrr = (_virtel) => { // NRR
  // v2 pojednostavljeni recnik kljuceva koji moze biti dvosmeran
  //
  // recnik kljuceva
  const recnik = multitranslator_v2_napravi_novi_prazan_recnikKljuceva();
  //
  // staro iz ter-export-lib-sastavnica-21r3-element-lib
  let j = {};
  let p = {};
  let virtel = {}
  if (_virtel && _virtel.virtelschemakey) {
    p = _virtel;
    virtel = _virtel;
  }
  //
  const _sublang_nrr = [
    "terkk$nrr/SKLOP_NRR",
    "terkk$nrr/P",
  ];
  //
  j.Par30 = p.distinction_key;
  _dodaj_v2(recnik,
    "terkk$nrr",
    [
      "terkk$nrr/SKLOP_NRR",
      "terkk$nrr/P",
    ], {
    by: "virtel_key",
    virtel_key: "distinction_key",
    value: virtel.distinction_key,
    sasint_key: "Par30",
    // cncvars_key: "",
    description: "distinction_key - preventuje isti ident čak i kad su svi ostali aprametri isti",
  });
  //
  j.Par1 = p.sirina;
  _dodaj_v2(recnik,
    "terkk$pkz",
    [
      "terkk$nrr/SKLOP_NRR",
      "terkk$nrr/P",
    ], {
    by: "virtel_key",
    virtel_key: "sirina",
    value: virtel.sirina,
    sasint_key: "Par1",
    // cncvars_key: "",
    description: "Širina",
  });
  //
  j.Par2 = p.visina;
  _dodaj_v2(recnik,
    "terkk$pkz",
    [
      "terkk$nrr/P",
    ], {
    by: "virtel_key",
    virtel_key: "visina",
    value: virtel.visina,
    sasint_key: "Par2",
    // cncvars_key: "",
    description: "Visina",
  });
  //
  j.Par3 = p.nrr_visinadonjesekcije;
  _dodaj_v2(recnik,
    "terkk$pkz",
    [
      "terkk$nrr/SKLOP_NRR",
    ], {
    by: "virtel_key",
    virtel_key: "nrr_visinadonjesekcije",
    value: virtel.nrr_visinadonjesekcije,
    sasint_key: "Par3",
    // cncvars_key: "",
    description: "NRR Visina donje sekcije",
  });
  //
  j.Par4 = p.nrr_visinadonjesekcije;
  _dodaj_v2(recnik,
    "terkk$pkz",
    [
      "terkk$nrr/SKLOP_NRR",
    ], {
    by: "virtel_key",
    virtel_key: "nrr_visinagornjesekcije",
    value: virtel.nrr_visinagornjesekcije,
    sasint_key: "Par4",
    // cncvars_key: "",
    description: "NRR Visina gornje sekcije",
  });
  //
  j.Par5 = p.duzinamodula;
  _dodaj_v2(recnik,
    "terkk$pkz",
    [
      "terkk$nrr/SKLOP_NRR",
    ], {
    by: "virtel_key",
    virtel_key: "duzinamodula",
    value: virtel.duzinamodula,
    sasint_key: "Par5",
    // cncvars_key: "",
    description: "Dužina modula",
  });
  //
  j.Par6 = p.nrr_visinarekuperatora;
  _dodaj_v2(recnik,
    "terkk$pkz",
    [
      "terkk$nrr/SKLOP_NRR",
    ], {
    by: "virtel_key",
    virtel_key: "nrr_visinarekuperatora",
    value: virtel.nrr_visinarekuperatora,
    sasint_key: "Par6",
    // cncvars_key: "",
    description: "NRR Visina rekuperatora",
  });
  //
  j.Par7 = p.nrr_debljinarekuperatora;
  _dodaj_v2(recnik,
    "terkk$pkz",
    [
      "terkk$nrr/SKLOP_NRR",
    ], {
    by: "virtel_key",
    virtel_key: "nrr_debljinarekuperatora",
    value: virtel.nrr_debljinarekuperatora,
    sasint_key: "Par7",
    // cncvars_key: "",
    description: "NRR Debljina rekuperatora",
  });
  //
  j.Par8 = p.tervrstaprofila_50_ili_70;
  _dodaj_v2(recnik,
    "terkk$pkz",
    [
      "terkk$nrr/SKLOP_NRR",
    ], {
    by: "virtel_key",
    virtel_key: "tervrstaprofila_50_ili_70",
    value: virtel.tervrstaprofila_50_ili_70,
    sasint_key: "Par8",
    // cncvars_key: "",
    description: "tervrstaprofila_50_ili_70",
  });
  //
  // return j;
  return recnik;
};


ter_recnik_kljuceva_maker.terkk$pal = (_virtel) => { // PPD
  // v2 pojednostavljeni recnik kljuceva koji moze biti dvosmeran
  //
  // recnik kljuceva
  const recnik = multitranslator_v2_napravi_novi_prazan_recnikKljuceva();
  //
  // staro iz ter-export-lib-sastavnica-21r3-element-lib
  let j = {};
  let p = {};
  let virtel = {}
  if (_virtel && _virtel.virtelschemakey) {
    p = _virtel;
    virtel = _virtel;
  }
  //
  const _sublang_paleta = [
    "terkk$pal/SKLOP_PALETA",
  ];
  //
  j.Par30 = p.distinction_key;
  _dodaj_v2(recnik,
    "terkk$pal",
    [
      "terkk$pal/SKLOP_PALETA",
    ], {
    by: "virtel_key",
    virtel_key: "distinction_key",
    value: virtel.distinction_key,
    sasint_key: "Par30",
    // cncvars_key: "",
    description: "distinction_key - preventuje isti ident čak i kad su svi ostali aprametri isti",
  });
  //
  j.Par1 = p.sirina;
  _dodaj_v2(recnik,
    "terkk$pal",
    [
      "terkk$pal/SKLOP_PALETA",
    ], {
    by: "virtel_key",
    virtel_key: "sirina",
    value: virtel.sirina,
    sasint_key: "Par1",
    // cncvars_key: "",
    description: "Širina",
  });
  //
  j.Par2 = p.duzina;
  _dodaj_v2(recnik,
    "terkk$pal",
    [
      "terkk$pal/SKLOP_PALETA",
    ], {
    by: "virtel_key",
    virtel_key: "duzina",
    value: virtel.duzina,
    sasint_key: "Par2",
    // cncvars_key: "",
    description: "Dužina",
  });
  //
  j.Par3 = p.visina;
  _dodaj_v2(recnik,
    "terkk$pal",
    [
      "terkk$pal/SKLOP_PALETA",
    ], {
    by: "virtel_key",
    virtel_key: "visina",
    value: virtel.visina,
    sasint_key: "Par3",
    // cncvars_key: "",
    description: "Visina",
  });
  //
  j.Par4 = p.pal_kolikoklocnisirinski;
  _dodaj_v2(recnik,
    "terkk$pal",
    [
      "terkk$pal/SKLOP_PALETA",
    ], {
    by: "virtel_key",
    virtel_key: "pal_kolikoklocnisirinski",
    value: virtel.pal_kolikoklocnisirinski,
    sasint_key: "Par4",
    // cncvars_key: "",
    description: "Broj klocni širinski",
  });
  //
  j.Par5 = p.pal_kolikoklocniduzinski;
  _dodaj_v2(recnik,
    "terkk$pal",
    [
      "terkk$pal/SKLOP_PALETA",
    ], {
    by: "virtel_key",
    virtel_key: "pal_kolikoklocniduzinski",
    value: virtel.pal_kolikoklocniduzinski,
    sasint_key: "Par5",
    // cncvars_key: "",
    description: "Broj klocni dužinski",
  });
  //
  j.Par6 = p.pal_kolikodasakasirinski;
  _dodaj_v2(recnik,
    "terkk$pal",
    [
      "terkk$pal/SKLOP_PALETA",
    ], {
    by: "virtel_key",
    virtel_key: "pal_kolikodasakasirinski",
    value: virtel.pal_kolikodasakasirinski,
    sasint_key: "Par6",
    // cncvars_key: "",
    description: "Broj dasaka širinski",
  });
  //
  j.Par7 = p.pal_kolikodasakaduzinski;
  _dodaj_v2(recnik,
    "terkk$pal",
    [
      "terkk$pal/SKLOP_PALETA",
    ], {
    by: "virtel_key",
    virtel_key: "pal_kolikodasakaduzinski",
    value: virtel.pal_kolikodasakaduzinski,
    sasint_key: "Par7",
    // cncvars_key: "",
    description: "Broj dasaka dužinski",
  });
  //
  j.Par8 = p.pal_toplotnotretiranje;
  _dodaj_v2(recnik,
    "terkk$pal",
    [
      "terkk$pal/SKLOP_PALETA",
    ], {
    by: "virtel_key",
    virtel_key: "pal_toplotnotretiranje",
    value: virtel.pal_toplotnotretiranje,
    sasint_key: "Par8",
    // cncvars_key: "",
    description: "Toplotno tretiranje",
  });
  //
  // return j;
  return recnik;
};


ter_recnik_kljuceva_maker.terkk$pov = (_virtel) => { // POV ???
  // v2 pojednostavljeni recnik kljuceva koji moze biti dvosmeran
  //
  // recnik kljuceva
  const recnik = multitranslator_v2_napravi_novi_prazan_recnikKljuceva();
  //
  // staro iz ter-export-lib-sastavnica-21r3-element-lib
  let j = {};
  let p = {};
  let virtel = {}
  if (_virtel && _virtel.virtelschemakey) {
    p = _virtel;
    virtel = _virtel;
  }
  //
  const _sublang_pov = [
    // "terkk$pov/SKLOP_POV",
    "terkk$pov/NOSAC",
  ];
  //
  j.Par30 = p.distinction_key;
  _dodaj_v2(recnik,
    "terkk$pov",
    [
      "terkk$pov/NOSAC",
    ], {
    by: "virtel_key",
    virtel_key: "distinction_key",
    value: virtel.distinction_key,
    sasint_key: "Par30",
    // cncvars_key: "",
    description: "distinction_key - preventuje isti ident čak i kad su svi ostali aprametri isti",
  });
  //
  j.Par1 = p.duzina;
  _dodaj_v2(recnik,
    "terkk$pov",
    [
      "terkk$pov/NOSAC",
    ], {
    by: "virtel_key",
    virtel_key: "duzina",
    value: virtel.duzina,
    sasint_key: "Par1",
    // cncvars_key: "",
    description: "Dužina",
  });
  //
  j.Par2 = p.visina;
  _dodaj_v2(recnik,
    "terkk$pov",
    [
      "terkk$pov/NOSAC",
    ], {
    by: "virtel_key",
    virtel_key: "visina",
    value: virtel.visina,
    sasint_key: "Par2",
    // cncvars_key: "",
    description: "Visina",
  });
  //
  // return j;
  return recnik;
};


ter_recnik_kljuceva_maker.terkk$ppd = (_virtel) => { // PPD
  // v2 pojednostavljeni recnik kljuceva koji moze biti dvosmeran
  //
  // recnik kljuceva
  const recnik = multitranslator_v2_napravi_novi_prazan_recnikKljuceva();
  //
  // staro iz ter-export-lib-sastavnica-21r3-element-lib
  let j = {};
  let p = {};
  let virtel = {}
  if (_virtel && _virtel.virtelschemakey) {
    p = _virtel;
    virtel = _virtel;
  }
  //
  const _sublang_ppd = [
    "terkk$ppd/SKLOP_PPD",
    "terkk$ppd/P1",
    "terkk$ppd/P2",
    "terkk$ppd/P3",
    "terkk$ppd/P4",
  ];
  //
  j.Par30 = p.distinction_key;
  _dodaj_v2(recnik,
    "terkk$ppd",
    [
      "terkk$ppd/SKLOP_PPD",
      "terkk$ppd/P1",
      "terkk$ppd/P2",
      "terkk$ppd/P3",
      "terkk$ppd/P4",
    ], {
    by: "virtel_key",
    virtel_key: "distinction_key",
    value: virtel.distinction_key,
    sasint_key: "Par30",
    // cncvars_key: "",
    description: "distinction_key - preventuje isti ident čak i kad su svi ostali aprametri isti",
  });
  //
  j.Par1 = p.ppd_b;
  _dodaj_v2(recnik,
    "terkk$ppd",
    [
      "terkk$ppd/SKLOP_PPD",
    ], {
    by: "virtel_key",
    virtel_key: "ppd_b",
    value: virtel.ppd_b,
    sasint_key: "Par1",
    // cncvars_key: "",
    description: "B Širina PPD-a",
  });
  //
  j.Par2 = p.ppd_h;
  _dodaj_v2(recnik,
    "terkk$ppd",
    [
      "terkk$ppd/SKLOP_PPD",
      "terkk$ppd/P2",
      "terkk$ppd/P4",
    ], {
    by: "virtel_key",
    virtel_key: "ppd_h",
    value: virtel.ppd_h,
    sasint_key: "Par2",
    // cncvars_key: "",
    description: "H Visina PPD-a",
  });
  //
  j.Par3 = p.ppd_unutrasnjasirinadempera_a;
  _dodaj_v2(recnik,
    "terkk$ppd",
    [
      "terkk$ppd/SKLOP_PPD",
      "terkk$ppd/P1",
      "terkk$ppd/P3",
    ], {
    by: "virtel_key",
    virtel_key: "ppd_unutrasnjasirinadempera_a",
    value: virtel.ppd_unutrasnjasirinadempera_a,
    sasint_key: "Par3",
    // cncvars_key: "",
    description: "Unutrasnja širina Dempera A",
  });
  //
  j.Par4 = p.ppd_unutrasnjavisinadempera_c;
  _dodaj_v2(recnik,
    "terkk$ppd",
    [
      "terkk$ppd/SKLOP_PPD",
    ], {
    by: "virtel_key",
    virtel_key: "ppd_unutrasnjavisinadempera_c",
    value: virtel.ppd_unutrasnjavisinadempera_c,
    sasint_key: "Par4",
    // cncvars_key: "",
    description: "Unutrasnja visina Dempera C",
  });
  //
  j.Par5 = p.ppd_g;
  _dodaj_v2(recnik,
    "terkk$ppd",
    [
      "terkk$ppd/SKLOP_PPD",
      "terkk$ppd/P2",
    ], {
    by: "virtel_key",
    virtel_key: "ppd_g",
    value: virtel.ppd_g,
    sasint_key: "Par5",
    // cncvars_key: "",
    description: "G Rastojanje od bočne strane do otvora",
  });
  //
  j.Par6 = p.ppd_i;
  _dodaj_v2(recnik,
    "terkk$ppd",
    [
      "terkk$ppd/SKLOP_PPD",
      "terkk$ppd/P4",
    ], {
    by: "virtel_key",
    virtel_key: "ppd_i",
    value: virtel.ppd_i,
    sasint_key: "Par6",
    // cncvars_key: "",
    description: "I Rastojanje 2 od bočne strane do otvora",
  });
  //
  j.Par7 = p.ppd_f;
  _dodaj_v2(recnik,
    "terkk$ppd",
    [
      "terkk$ppd/SKLOP_PPD",
      "terkk$ppd/P1",
      "terkk$ppd/P3",
    ], {
    by: "virtel_key",
    virtel_key: "ppd_f",
    value: virtel.ppd_f,
    sasint_key: "Par7",
    // cncvars_key: "",
    description: "F Rastojanje od dna do otvora",
  });
  //
  // return j;
  return recnik;
};


ter_recnik_kljuceva_maker.terkk$prb = (_virtel) => { // prigusivac buke
  // v2 pojednostavljeni recnik kljuceva koji moze biti dvosmeran
  //
  // recnik kljuceva
  const recnik = multitranslator_v2_napravi_novi_prazan_recnikKljuceva();
  //
  // staro iz ter-export-lib-sastavnica-21r3-element-lib
  let j = {};
  let p = {};
  let virtel = {}
  if (_virtel && _virtel.virtelschemakey) {
    p = _virtel;
    virtel = _virtel;
  }
  //
  const _sublang_prb = [
    "terkk$prb/SKLOP_KULISA",
    "terkk$prb/SKLOP_NOSAC",
    "terkk$prb/ELEMENT_KULISE",
    "terkk$prb/U_PROFIL",
    "terkk$prb/KAMENA_VUNA",
    "terkk$prb/LIM_OMEGA",
    "terkk$prb/SET_STEZACA",
  ];
  //
  j.Par1 = p.duzina;
  _dodaj_v2(recnik,
    "terkk$prb",
    [
      "terkk$prb/SKLOP_KULISA",
      "terkk$prb/ELEMENT_KULISE",
      "terkk$prb/U_PROFIL",
      "terkk$prb/KAMENA_VUNA",
      "terkk$prb/SKLOP_NOSAC",
      "terkk$prb/LIM_OMEGA",
    ], {
    by: "virtel_key",
    virtel_key: "duzina",
    value: virtel.duzina,
    sasint_key: "Par1",
    cncvars_key: "$duzina$",
    description: "Dužina",
  });
  //
  j.Par2 = p.visina;
  _dodaj_v2(recnik,
    "terkk$prb",
    [
      "terkk$prb/SKLOP_KULISA",
      "terkk$prb/KAMENA_VUNA",
      "terkk$prb/SKLOP_NOSAC",
      "terkk$prb/LIM_OMEGA",
    ], {
    by: "virtel_key",
    virtel_key: "visina",
    value: virtel.visina,
    sasint_key: "Par2",
    description: "Visina",
  });
  //
  j.Par3 = p.sirina;
  _dodaj_v2(recnik,
    "terkk$prb",
    [
      "terkk$prb/SKLOP_KULISA",
      "terkk$prb/ELEMENT_KULISE",
      "terkk$prb/U_PROFIL",
      "terkk$prb/KAMENA_VUNA",
      "terkk$prb/SKLOP_NOSAC",
      "terkk$prb/LIM_OMEGA",
      "terkk$prb/SET_STEZACA",
    ], {
    by: "virtel_key",
    virtel_key: "sirina",
    value: virtel.sirina,
    sasint_key: "Par3",
    cncvars_key: "$sirina$",
    description: "Širina",
  });
  //
  /*
  j.Par4 = p.debljina;
  _dodaj_v2(recnik,
    "terkk$prb",
    [
      "terkk$prb/KAMENA_VUNA",
    ], {
    by: "virtel_key",
    virtel_key: "debljina",
    value: virtel.debljina,
    sasint_key: "Par4",
    description: "Debljina",
  });
  */
  //
  j.Par4 = p.prb_rastojanjeizmedjukulisa;
  _dodaj_v2(recnik,
    "terkk$prb",
    [
      "terkk$prb/SKLOP_NOSAC",
      "terkk$prb/LIM_OMEGA",
    ], {
    by: "virtel_key",
    virtel_key: "prb_rastojanjeizmedjukulisa",
    value: virtel.prb_rastojanjeizmedjukulisa,
    sasint_key: "Par4",
    description: "Rastojanje izmedju kulisa",
  });
  //
  j.Par5 = p.prbnosac_brojkomadausetustezaca;
  _dodaj_v2(recnik,
    "terkk$prb",
    [
      "terkk$prb/SET_STEZACA",
    ], {
    by: "virtel_key",
    virtel_key: "prbnosac_brojkomadausetustezaca",
    value: virtel.prbnosac_brojkomadausetustezaca,
    sasint_key: "Par5",
    description: "Broj komada u setu",
  });
  //
  j.Par6 = p.ter_koji_deo_visedelnog;
  _dodaj_v2(recnik,
    "terkk$prb",
    [
      "terkk$prb/LIM_OMEGA",
    ], {
    by: "virtel_key",
    virtel_key: "ter_koji_deo_visedelnog",
    value: virtel.ter_koji_deo_visedelnog,
    sasint_key: "Par6",
    description: "Koji deo od višedelnog",
  });
  //
  // return j;
  return recnik;
};


ter_recnik_kljuceva_maker.terkk$pkz = (_virtel) => { // PKZ
  // v2 pojednostavljeni recnik kljuceva koji moze biti dvosmeran
  //
  // recnik kljuceva
  const recnik = multitranslator_v2_napravi_novi_prazan_recnikKljuceva();
  //
  // staro iz ter-export-lib-sastavnica-21r3-element-lib
  let j = {};
  let p = {};
  let virtel = {}
  if (_virtel && _virtel.virtelschemakey) {
    p = _virtel;
    virtel = _virtel;
  }
  //
  const _sublang_pkz = [
    "terkk$pkz/SKLOP_PKZ",
    "terkk$pkz/P1234",
    "terkk$pkz/P5",
  ];
  //
  j.Par30 = p.distinction_key;
  _dodaj_v2(recnik,
    "terkk$pkz",
    [
      "terkk$pkz/SKLOP_PKZ",
      "terkk$pkz/P1234",
      "terkk$pkz/P5",
    ], {
    by: "virtel_key",
    virtel_key: "distinction_key",
    value: virtel.distinction_key,
    sasint_key: "Par30",
    // cncvars_key: "",
    description: "distinction_key - preventuje isti ident čak i kad su svi ostali aprametri isti",
  });
  //
  j.Par1 = p.pkz_sirinasvetlogotvora;
  _dodaj_v2(recnik,
    "terkk$pkz",
    [
      "terkk$pkz/SKLOP_PKZ",
      "terkk$pkz/P1234",
      "terkk$pkz/P5",
    ], {
    by: "virtel_key",
    virtel_key: "pkz_sirinasvetlogotvora",
    value: virtel.pkz_sirinasvetlogotvora,
    sasint_key: "Par1",
    // cncvars_key: "",
    description: "Širina svetlog otvora",
  });
  //
  j.Par2 = p.pkz_visinasvetlogotvora;
  _dodaj_v2(recnik,
    "terkk$pkz",
    [
      "terkk$pkz/SKLOP_PKZ",
      "terkk$pkz/P1234",
      "terkk$pkz/P5",
    ], {
    by: "virtel_key",
    virtel_key: "pkz_visinasvetlogotvora",
    value: virtel.pkz_visinasvetlogotvora,
    sasint_key: "Par2",
    // cncvars_key: "",
    description: "Visina svetlog otvora",
  });
  //
  j.Par3 = p.duzina;
  _dodaj_v2(recnik,
    "terkk$pkz",
    [
      "terkk$pkz/P1234",
      "terkk$pkz/P5",
    ], {
    by: "virtel_key",
    virtel_key: "duzina",
    value: virtel.duzina,
    sasint_key: "Par3",
    // cncvars_key: "",
    description: "Dužina",
  });
  //
  j.Par4 = p.sirina;
  _dodaj_v2(recnik,
    "terkk$pkz",
    [
      "terkk$pkz/P1234",
      "terkk$pkz/P5",
    ], {
    by: "virtel_key",
    virtel_key: "sirina",
    value: virtel.sirina,
    sasint_key: "Par4",
    // cncvars_key: "",
    description: "Širina",
  });
  //
  j.Par5 = p.pkz_brojdelova;
  _dodaj_v2(recnik,
    "terkk$pkz",
    [
      "terkk$pkz/SKLOP_PKZ",
      "terkk$pkz/P5",
    ], {
    by: "virtel_key",
    virtel_key: "pkz_brojdelova",
    value: virtel.pkz_brojdelova,
    sasint_key: "Par5",
    // cncvars_key: "",
    description: "PKZ Broj delova",
  });
  //
  j.Par6 = p.pkz_brojredova;
  _dodaj_v2(recnik,
    "terkk$pkz",
    [
      "terkk$pkz/SKLOP_PKZ",
    ], {
    by: "virtel_key",
    virtel_key: "pkz_brojredova",
    value: virtel.pkz_brojredova,
    sasint_key: "Par6",
    // cncvars_key: "",
    description: "PKZ Broj redova",
  });
  //
  // return j;
  return recnik;
};


ter_recnik_kljuceva_maker.terkk$rfi = (_virtel) => { // RFI ramfiltera ???
  // v2 pojednostavljeni recnik kljuceva koji moze biti dvosmeran
  //
  // recnik kljuceva
  const recnik = multitranslator_v2_napravi_novi_prazan_recnikKljuceva();
  //
  // staro iz ter-export-lib-sastavnica-21r3-element-lib
  let j = {};
  let p = {};
  let virtel = {}
  if (_virtel && _virtel.virtelschemakey) {
    p = _virtel;
    virtel = _virtel;
  }
  //
  const _sublang_rfi = [
    // "terkk$rfi/SKLOP_RFI",
    "terkk$rfi/NOSAC",
    "terkk$rfi/UKRUCENJE",
    "terkk$rfi/SET_STEZACA",
  ];
  //
  j.Par30 = p.distinction_key;
  _dodaj_v2(recnik,
    "terkk$rfi",
    [
      "terkk$rfi/NOSAC",
      "terkk$rfi/UKRUCENJE",
      "terkk$rfi/SET_STEZACA",
    ], {
    by: "virtel_key",
    virtel_key: "distinction_key",
    value: virtel.distinction_key,
    sasint_key: "Par30",
    // cncvars_key: "",
    description: "distinction_key - preventuje isti ident čak i kad su svi ostali aprametri isti",
  });
  //
  j.Par1 = p.duzina;
  _dodaj_v2(recnik,
    "terkk$rfi",
    [
      "terkk$rfi/NOSAC",
      "terkk$rfi/UKRUCENJE",
      "terkk$rfi/SET_STEZACA",
    ], {
    by: "virtel_key",
    virtel_key: "duzina",
    value: virtel.duzina,
    sasint_key: "Par1",
    // cncvars_key: "",
    description: "Dužina",
  });
  //
  j.Par2 = p.sirina;
  _dodaj_v2(recnik,
    "terkk$rfi",
    [
      "terkk$rfi/NOSAC",
      "terkk$rfi/UKRUCENJE",
      "terkk$rfi/SET_STEZACA",
    ], {
    by: "virtel_key",
    virtel_key: "sirina",
    value: virtel.sirina,
    sasint_key: "Par2",
    // cncvars_key: "",
    description: "Širina",
  });
  //
  j.Par3 = p.visina;
  _dodaj_v2(recnik,
    "terkk$rfi",
    [
      "terkk$rfi/NOSAC",
    ], {
    by: "virtel_key",
    virtel_key: "visina",
    value: virtel.visina,
    sasint_key: "Par3",
    // cncvars_key: "",
    description: "Visina",
  });
  //
  j.Par4 = p.ter_visedelni_koliko_delova;
  _dodaj_v2(recnik,
    "terkk$rfi",
    [
      "terkk$rfi/NOSAC",
    ], {
    by: "virtel_key",
    virtel_key: "ter_visedelni_koliko_delova",
    value: virtel.ter_visedelni_koliko_delova,
    sasint_key: "Par4",
    description: "Višpedelni sa koliko delova",
  });
  //
  j.Par5 = p.rfi_brojkomadausetustezaca;
  _dodaj_v2(recnik,
    "terkk$prb",
    [
      "terkk$rfi/SET_STEZACA",
    ], {
    by: "virtel_key",
    virtel_key: "rfi_brojkomadausetustezaca",
    value: virtel.rfi_brojkomadausetustezaca,
    sasint_key: "Par5",
    description: "Broj komada u setu",
  });
  //
  // return j;
  return recnik;
};


ter_recnik_kljuceva_maker.terkk$ramfuk = (_virtel) => { // RAMFUK
  // v2 pojednostavljeni recnik kljuceva koji moze biti dvosmeran
  //
  // recnik kljuceva
  const recnik = multitranslator_v2_napravi_novi_prazan_recnikKljuceva();
  //
  // staro iz ter-export-lib-sastavnica-21r3-element-lib
  let j = {};
  let p = {};
  let virtel = {}
  if (_virtel && _virtel.virtelschemakey) {
    p = _virtel;
    virtel = _virtel;
  }
  //
  const _sublang_prb = [
    "terkk$ramfuk/SKLOP_RAMFUK",
    "terkk$ramfuk/NOSAC_V",
    "terkk$ramfuk/NOSAC_OMEGA",
    "terkk$ramfuk/KLIZAC_GORNJI_DONJI",
    "terkk$ramfuk/GRANICNIK",
    "terkk$ramfuk/OJACANJE_V_UPROFIL",
    "terkk$ramfuk/DISTANCER_DUPLOG_KLIZACA",
  ];
  //
  j.Par1 = p.sirina;
  _dodaj_v2(recnik,
    "terkk$prb",
    [
      "terkk$ramfuk/SKLOP_RAMFUK",
      "terkk$ramfuk/NOSAC_OMEGA",
      "terkk$ramfuk/KLIZAC_GORNJI_DONJI",
      "terkk$ramfuk/GRANICNIK",
    ], {
    by: "virtel_key",
    virtel_key: "sirina",
    value: virtel.sirina,
    sasint_key: "Par1",
    description: "Širina",
  });
  //
  j.Par2 = p.visina;
  _dodaj_v2(recnik,
    "terkk$prb",
    [
      "terkk$ramfuk/SKLOP_RAMFUK",
      "terkk$ramfuk/NOSAC_V",
      "terkk$ramfuk/OJACANJE_V_UPROFIL",
      "terkk$ramfuk/DISTANCER_DUPLOG_KLIZACA",
    ], {
    by: "virtel_key",
    virtel_key: "visina",
    value: virtel.visina,
    sasint_key: "Par2",
    description: "Visina",
  });
  //
  j.Par3 = p.tervrstaprofila_50_ili_70;
  _dodaj_v2(recnik,
    "terkk$prb",
    [
      "terkk$ramfuk/SKLOP_RAMFUK",
      "terkk$ramfuk/NOSAC_OMEGA",
    ], {
    by: "virtel_key",
    virtel_key: "tervrstaprofila_50_ili_70",
    value: virtel.tervrstaprofila_50_ili_70,
    sasint_key: "Par3",
    description: "tervrstaprofila_50_ili_70",
  });
  //
  j.Par4 = p.ramfuk_tipfiltera;
  _dodaj_v2(recnik,
    "terkk$prb",
    [
      "terkk$ramfuk/SKLOP_RAMFUK",
      "terkk$ramfuk/KLIZAC_GORNJI_DONJI",
      "terkk$ramfuk/GRANICNIK",
    ], {
    by: "virtel_key",
    virtel_key: "ramfuk_tipfiltera",
    value: virtel.ramfuk_tipfiltera,
    sasint_key: "Par4",
    description: "ramfuk_tipfiltera",
  });

  //
  j.Par5 = p.ter_koji_deo_visedelnog;
  _dodaj_v2(recnik,
    "terkk$prb",
    [
      "terkk$ramfuk/NOSAC_OMEGA",
      "terkk$ramfuk/KLIZAC_GORNJI_DONJI",
    ], {
    by: "virtel_key",
    virtel_key: "ter_koji_deo_visedelnog",
    value: virtel.ter_koji_deo_visedelnog,
    sasint_key: "Par5",
    description: "Koji deo od višedelnog",
  });
  //
  // return j;
  return recnik;
};


ter_recnik_kljuceva_maker.terkk$rmt = (_virtel) => { // RMT
  // v2 pojednostavljeni recnik kljuceva koji moze biti dvosmeran
  //
  // recnik kljuceva
  const recnik = multitranslator_v2_napravi_novi_prazan_recnikKljuceva();
  //
  // staro iz ter-export-lib-sastavnica-21r3-element-lib
  let j = {};
  let p = {};
  let virtel = {}
  if (_virtel && _virtel.virtelschemakey) {
    p = _virtel;
    virtel = _virtel;
  }
  //
  const _sublang_rmt = [
    "terkk$rmt/SKLOP_RMT",
    "terkk$rmt/NOSAC_TERMOSTATA",
    "terkk$rmt/LIM_OMEGA",
    "terkk$rmt/LIM_U",
  ];
  //
  j.Par1 = p.sirina;
  _dodaj_v2(recnik,
    "terkk$rmt",
    [
      "terkk$rmt/SKLOP_RMT",
      "terkk$rmt/SKLOP_RMT_KLIZAC",
      "terkk$rmt/NOSAC_TERMOSTATA",
      "terkk$rmt/LIM_OMEGA",
      "terkk$rmt/LIM_U",
    ], {
    by: "virtel_key",
    virtel_key: "sirina",
    value: virtel.sirina,
    sasint_key: "Par1",
    cncvars_key: "$sirina$",
    description: "Širina",
  });
  //
  j.Par2 = p.visina;
  _dodaj_v2(recnik,
    "terkk$rmt",
    [
      "terkk$rmt/SKLOP_RMT",
    ], {
    by: "virtel_key",
    virtel_key: "visina",
    value: virtel.visina,
    sasint_key: "Par2",
    cncvars_key: "$visina$",
    description: "Visina",
  });
  //
  j.Par3 = p.tervrstaprofila_50_ili_70;
  _dodaj_v2(recnik,
    "terkk$rmt",
    [
      "terkk$rmt/SKLOP_RMT_KLIZAC",
    ], {
    by: "virtel_key",
    virtel_key: "tervrstaprofila_50_ili_70",
    value: virtel.tervrstaprofila_50_ili_70,
    sasint_key: "Par3",
    description: "tervrstaprofila_50_ili_70",
  });
  //
  j.Par4 = p.ter_koji_deo_visedelnog; //
  _dodaj_v2(recnik,
    "terkk$rmt",
    [
      "terkk$rmt/LIM_OMEGA",
      "terkk$rmt/LIM_U",
    ], {
    by: "virtel_key",
    virtel_key: "ter_koji_deo_visedelnog",
    value: virtel.ter_koji_deo_visedelnog,
    sasint_key: "Par4",
    description: "Koji deo od višedelnog",
  });
  //
  // return j;
  return recnik;
};


ter_recnik_kljuceva_maker.terkk$usmv = (_virtel) => { // usmerivacvazduha ???
  // v2 pojednostavljeni recnik kljuceva koji moze biti dvosmeran
  //
  // recnik kljuceva
  const recnik = multitranslator_v2_napravi_novi_prazan_recnikKljuceva();
  //
  // staro iz ter-export-lib-sastavnica-21r3-element-lib
  let j = {};
  let p = {};
  let virtel = {}
  if (_virtel && _virtel.virtelschemakey) {
    p = _virtel;
    virtel = _virtel;
  }
  //
  const _sublang_usmv = [
    "terkk$usmv/SKLOP_USMV",
    "terkk$usmv/P",
  ];
  //
  j.Par1 = p.novo;
  _dodaj_v2(recnik,
    "terkk$usmv",
    [
      "terkk$usmv/SKLOP_USMV",
      "terkk$usmv/P",
    ], {
    by: "virtel_key",
    virtel_key: "novo",
    value: virtel.novo,
    sasint_key: "Par1",
    // cncvars_key: "",
    description: "?",
  });
  //
  // return j;
  return recnik;
};


// ----- zavrseno dodavnje reci i prevoda u recnike


//
const ter_recnik_kljuceva_optimize_for_export_by_sasexcel_key = (ter_recnik_kljuceva_lib_optimized) => {
  const recn = ter_recnik_kljuceva_lib_optimized;
  let recnik_for_export = {};
  Object.keys(recn).forEach((superlang) => {
    const subrecn = recn[superlang].subrecnik.virtel_key;
    recnik_for_export[superlang] = {};
    Object.keys(subrecn).forEach((virtel_key) => {
      const multiprevodJednogKljuca = subrecn[virtel_key];
      const sasexcel_key = multiprevodJednogKljuca.sasexcel_key;
      if (sasexcel_key) {
        // samo kljucevi koji postoje u excelu za export
        const virtel_key = multiprevodJednogKljuca.virtel_key;
        const sasint_key = multiprevodJednogKljuca.sasint_key;
        const cncvars_key = multiprevodJednogKljuca.cncvars_key;
        const description = multiprevodJednogKljuca.description;
        // populate every superlang and ecery multitranslator_lang (superlang/sublang)
        if (recnik_for_export[superlang]) {
          // already exist // do nothing
        } else {
          recnik_for_export[superlang] = {};
        }
        multiprevodJednogKljuca._sublang_arr.forEach((multitranslator_lang) => {
          if (recnik_for_export[multitranslator_lang]) {
            // already exist // do nothing
          } else {
            recnik_for_export[multitranslator_lang] = {};
          }
          if (recnik_for_export[multitranslator_lang][sasexcel_key]) {
            // already exist // do nothing
          } else {
            recnik_for_export[multitranslator_lang][sasexcel_key] = {};
          }
          if (recnik_for_export[superlang][sasexcel_key]) {
            // already exist // do nothing
          } else {
            recnik_for_export[superlang][sasexcel_key] = {};
          }
          if (description) {
            recnik_for_export[multitranslator_lang][sasexcel_key].description = description;
            recnik_for_export[superlang][sasexcel_key].description = description;
          } else {
            recnik_for_export[multitranslator_lang][sasexcel_key].description = "?";
            recnik_for_export[superlang][sasexcel_key].description = "?";
          }
          if (sasexcel_key) {
            recnik_for_export[multitranslator_lang][sasexcel_key].sasexcel_key = sasexcel_key;
            recnik_for_export[superlang][sasexcel_key].sasexcel_key = sasexcel_key;
          }
          if (sasint_key) {
            recnik_for_export[multitranslator_lang][sasexcel_key].sasint_key = sasint_key;
            recnik_for_export[superlang][sasexcel_key].sasint_key = sasint_key;
          }
          if (cncvars_key) {
            recnik_for_export[multitranslator_lang][sasexcel_key].cncvars_key = cncvars_key;
            recnik_for_export[superlang][sasexcel_key].cncvars_key = cncvars_key;
          }
          if (virtel_key) {
            recnik_for_export[multitranslator_lang][sasexcel_key].virtel_key = virtel_key;
            recnik_for_export[superlang][sasexcel_key].virtel_key = virtel_key;
          }
        });
      }
    });
  });
  //
  console.log('recnik kljuceva OPTIMIZED FOR EDXPORT BY sasexcel_key', recnik_for_export);
};


//
export const ter_recnik_kljuceva_init = (key) => {
  const superlang_klimakomora = 'terkk$klimakomora';
  const superlang_modul = 'terkk$modul';
  const superlang_grupa_profil = 'terkk$grupa_profil';
  const superlang_grupa_ispuna = 'terkk$grupa_ispuna';
  const superlang_ppv1 = 'terkk$ppv_sekcija';
  const superlang_ppv2 = 'terkk$ppv';
  const superlang_ppvnosacv = 'terkk$ppvnosacv';
  const superlang_postolje = 'terkk$postolje';
  const superlang_postolje2 = 'terkk$postolje_profil';
  const superlang_kadica = 'terkk$kadica';
  const superlang_krov = 'terkk$krov';
  const superlang_klizac = 'terkk$klizac';
  const superlang_kelg = 'terkk$kelg';
  const superlang_npr = 'terkk$npr';
  const superlang_nrr = 'terkk$nrr';
  const superlang_paleta = 'terkk$pal';
  const superlang_pov = 'terkk$pov';
  const superlang_ppd = 'terkk$ppd';
  const superlang_prb = 'terkk$prb';
  const superlang_pkz = 'terkk$pkz';
  const superlang_rfi = 'terkk$rfi';
  const superlang_ramfuk = 'terkk$ramfuk';
  const superlang_rmt = 'terkk$rmt';
  const superlang_usmv = 'terkk$usmv';
  //
  ter_recnik_kljuceva_lib_optimized[superlang_klimakomora] = ter_recnik_kljuceva_maker[superlang_klimakomora]();
  ter_recnik_kljuceva_lib_optimized[superlang_modul] = ter_recnik_kljuceva_maker[superlang_modul]();
  ter_recnik_kljuceva_lib_optimized[superlang_grupa_profil] = ter_recnik_kljuceva_maker[superlang_grupa_profil]();
  ter_recnik_kljuceva_lib_optimized[superlang_grupa_ispuna] = ter_recnik_kljuceva_maker[superlang_grupa_ispuna]();
  const _recnik_kljuceva_ppv_sekcija = ter_recnik_kljuceva_maker[superlang_ppv1]();
  ter_recnik_kljuceva_lib_optimized[superlang_ppv1] = _recnik_kljuceva_ppv_sekcija;
  ter_recnik_kljuceva_lib_optimized[superlang_ppv2] = _recnik_kljuceva_ppv_sekcija; // same reference
  ter_recnik_kljuceva_lib_optimized[superlang_ppvnosacv] = ter_recnik_kljuceva_maker[superlang_ppvnosacv]();
  ter_recnik_kljuceva_lib_optimized[superlang_postolje] = ter_recnik_kljuceva_maker[superlang_postolje]();
  ter_recnik_kljuceva_lib_optimized[superlang_postolje2] = ter_recnik_kljuceva_maker[superlang_postolje]();
  ter_recnik_kljuceva_lib_optimized[superlang_kadica] = ter_recnik_kljuceva_maker[superlang_kadica]();
  ter_recnik_kljuceva_lib_optimized[superlang_krov] = ter_recnik_kljuceva_maker[superlang_krov]();
  ter_recnik_kljuceva_lib_optimized[superlang_klizac] = ter_recnik_kljuceva_maker[superlang_klizac]();
  ter_recnik_kljuceva_lib_optimized[superlang_kelg] = ter_recnik_kljuceva_maker[superlang_kelg]();
  ter_recnik_kljuceva_lib_optimized[superlang_npr] = ter_recnik_kljuceva_maker[superlang_npr]();
  ter_recnik_kljuceva_lib_optimized[superlang_nrr] = ter_recnik_kljuceva_maker[superlang_nrr]();
  ter_recnik_kljuceva_lib_optimized[superlang_paleta] = ter_recnik_kljuceva_maker[superlang_paleta]();
  ter_recnik_kljuceva_lib_optimized[superlang_pov] = ter_recnik_kljuceva_maker[superlang_pov]();
  ter_recnik_kljuceva_lib_optimized[superlang_ppd] = ter_recnik_kljuceva_maker[superlang_ppd]();
  ter_recnik_kljuceva_lib_optimized[superlang_prb] = ter_recnik_kljuceva_maker[superlang_prb]();
  ter_recnik_kljuceva_lib_optimized[superlang_pkz] = ter_recnik_kljuceva_maker[superlang_pkz]();
  ter_recnik_kljuceva_lib_optimized[superlang_rfi] = ter_recnik_kljuceva_maker[superlang_rfi]();
  ter_recnik_kljuceva_lib_optimized[superlang_ramfuk] = ter_recnik_kljuceva_maker[superlang_ramfuk]();
  ter_recnik_kljuceva_lib_optimized[superlang_rmt] = ter_recnik_kljuceva_maker[superlang_rmt]();
  // ter_recnik_kljuceva_lib_optimized[superlang_usmv] = ter_recnik_kljuceva_maker[superlang_usmv]();
  ter_recnik_kljuceva_initialized = true;
  console.log('ter_recnik_kljuceva OPTIMIZED', ter_recnik_kljuceva_lib_optimized);
  // also do optimize for export
  ter_recnik_kljuceva_optimize_for_export_by_sasexcel_key(ter_recnik_kljuceva_lib_optimized)
};


//
export const ter_recnik_kljuceva_smart_get = (_jezik) => {
  //
  if (ter_recnik_kljuceva_initialized === false) {
    console.log('WARNING ter_recnik_kljuceva_lib is not initialized. We will initialize it now.');
    ter_recnik_kljuceva_init();
  }
  //
  const superlang = multitranslator_v2_extract_superlang_from_jezik(_jezik);
  // console.log('_jezik', _jezik, 'superlang', superlang);
  let recnik_kljuceva = false;
  if (ter_recnik_kljuceva_lib_optimized[superlang]) {
    recnik_kljuceva = ter_recnik_kljuceva_lib_optimized[superlang]
  }
  // console.log('ter_recnik_kljuceva_smart_get RETURNING recnik_kljuceva', recnik_kljuceva);
  return recnik_kljuceva;
};

